var utils = require('./tripletrax.utils.js');
var ajax = require('./tripletrax.ajax.js');
var validator = require('./tripletrax.validator.js');
var monitoring = require('./tripletrax.monitoring.js');

function registerIntegritiesEvents() {

    // Integritäten - Ändern des Typs (Anzeige der dazugehörigen Felder)
    $('body').on('change', '.tt-select-integrity-type', function (e) {

        // Felder zurücksetzen
        $(this).parents('form').find('.tt-integrity-specific-values').find('input[type="hidden"]').val("");
        $(this).parents('form').find('.tt-integrity-specific-values').find('input:not([type="radio"])').val("");
        if ($(this).parents('form').find('.tt-integrity-specific-values').find('.datepicker').length) {
            $(this).parents('form').find('.tt-integrity-specific-values').find('.datepicker').data('picker').setDate(null);
        }
        $(this).parents('form').find('.tt-integrity-specific-values').find('[type="radio"],[type="checkbox"]').prop('checked', false);
        $(this).parents('form').find('.tt-integrity-specific-values').find('.tt-select2.select2-hidden-accessible').val(null).trigger('change.select2');
        $(this).parents('form').find('[name="integrity_age_from_field"]').val($(this).parents('form').find('.tt-birth-date-data-view').val()).trigger('change.select2');
        $(this).parents('form').find('[name="integrity_age_till_field"]').val($(this).parents('form').find('.tt-birth-date-data-view').val()).trigger('change.select2');
        $(this).parents('form').find('.tt-integrity-specific-values').find('.tt-select2').removeAttr('disabled');
        jQuery.each($(this).parents('form').find('.tt-integrity-specific-values').find('.tt-date-dropdown'), function (i, val) {
            utils.setValueForInputWithDropDownField($(val).parent(), 'years', true);
        });

        if (!utils.isUndefined($(this).select2('val')) && $(this).select2('val') !== '') {
            $(this).parents('form').find('[name="integrity_custom_rule"]').val(null).trigger('change.select2');
        }

        // inaktive Felder neu setzen

        // Wertebereich (Input)
        if ($(this).parents('form').find('.tt-range-input').length) {
            $(this).parents('form').find('.tt-range-input').find('[name="integrity_logical_till_field"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-range-input').find('[name="integrity_value_till"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-range-input').find('[name="integrity_value_till"]').parent().addClass('state-disabled');
            $(this).parents('form').find('.tt-range-input').find('[name="integrity_value_till_dropdown_toggle"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-range-input').find('[name="integrity_value_till_field"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-range-input').find('[name="integrity_value_till_field_unit_1"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-range-input').find('[name="integrity_value_till_field_unit_2"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-range-date').find('[name="integrity_value_till_plus_minus"]').prop('disabled', 'disabled');
        }

        // Wertebereich (Datum)
        if ($(this).parents('form').find('.tt-range-date').length) {
            $(this).parents('form').find('.tt-range-date').find('[name="integrity_logical_till_date_field"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-range-date').find('[name="integrity_value_till_date_field"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-range-date').find('[name="integrity_value_till_date_range"]').parent().addClass('state-disabled');
            $(this).parents('form').find('.tt-range-date').find('[name="integrity_value_till_date_dropdown_toggle"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-range-date').find('[name="integrity_value_till_date_range"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-range-date').find('[name="integrity_value_till_plus_minus"]').prop('disabled', 'disabled');
        }

        // Abhängigkeit - Feld (Input)
        if ($(this).parents('form').find('.tt-field-input-numeric').length) {
            $(this).parents('form').find('.tt-field-input-numeric').find('[name="integrity_field_logical_till_field"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-field-input-numeric').find('[name="integrity_field_value_till"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-field-input-numeric').find('[name="integrity_field_value_till"]').parent().addClass('state-disabled');
            $(this).parents('form').find('.tt-field-input-numeric').find('[name="integrity_field_value_till_dropdown_toggle"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-field-input-numeric').find('[name="integrity_field_value_till_field"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-field-input-numeric').find('[name="integrity_field_value_till_plus_minus"]').prop('disabled', 'disabled');
        }

        // Abhängigkeit - Feld (Datum)
        if ($(this).parents('form').find('.tt-field-date').length) {
            $(this).parents('form').find('.tt-field-date').find('[name="integrity_field_logical_till_date_field"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-field-date').find('[name="integrity_field_value_till_date_field"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-field-date').find('[name="integrity_field_value_till_date_range"]').parent().addClass('state-disabled');
            $(this).parents('form').find('.tt-field-date').find('[name="integrity_field_value_till_date_dropdown_toggle"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-field-date').find('[name="integrity_field_value_till_date_range"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-field-date').find('[name="integrity_field_value_till_plus_minus"]').prop('disabled', 'disabled');
        }

        // Abhängigkeit - abhängiges Feld (Input)
        if ($(this).parents('form').find('.tt-depending-field-input-numeric').length) {
            $(this).parents('form').find('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_logical_till_field"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_value_till"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_value_till"]').parent().addClass('state-disabled');
            $(this).parents('form').find('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_value_till_dropdown_toggle"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_value_till_field"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_value_till_plus_minus"]').prop('disabled', 'disabled');
        }

        // Abhängigkeit - abhängiges Feld (Datum)
        if ($(this).parents('form').find('.tt-depending-field-date').length) {
            $(this).parents('form').find('.tt-depending-field-date').find('[name="integrity_depending_field_logical_till_date_field"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-depending-field-date').find('[name="integrity_depending_field_value_till_date_field"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-depending-field-date').find('[name="integrity_depending_field_value_till_date_range"]').parent().addClass('state-disabled');
            $(this).parents('form').find('.tt-depending-field-date').find('[name="integrity_depending_field_value_till_date_dropdown_toggle"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-depending-field-date').find('[name="integrity_depending_field_value_till_date_range"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-depending-field-date').find('[name="integrity_depending_field_value_till_plus_minus"]').prop('disabled', 'disabled');
        }

        var select2 = this;
        showIntegritySpecificFieldsOfValue(select2);
        showIntegrityDependencySpecificFieldsOfDepValue($(select2).parents('.modal-content').find('[name="integrity_depending_field"]')).done(function() {

            $(select2).parents('form').find('.tt-select2[name$="_age_from_field"],.tt-select2[name$="_age_till_field"]').val($(select2).parents('form').find('.tt-birth-date-data-view').val()).trigger('change.select2');

            if ($(select2).select2('val') === 'dependency' || $(select2).select2('val') === 'completeness') {
                validator.triggerValidation($(select2).parents('form').find('[name="integrity_integritytype"]')[0], true, false);
            }
        });
    });

    // Integritäten - Ändern des abhängigen Feldes (Abhängigkeit)
    $('body').on('change', '.tt-integrity-depending-field,.tt-dependency-completeness-group', function (e) {
        $(this).parents('form').find('.tt-depending-field-values').find('input[type="hidden"]').val("");
        $(this).parents('form').find('.tt-depending-field-values').find('input:not([type="radio"])').val("");
        if ($(this).parents('form').find('.tt-depending-field-values').find('.datepicker')-length) {
            $(this).parents('form').find('.tt-depending-field-values').find('.datepicker').data('picker').setDate(null);
        }
        $(this).parents('form').find('.tt-depending-field-values').find('[type="radio"]:not([name="integrity_dependency_frequency"]),[type="checkbox"]').prop('checked', false);
        $(this).parents('form').find('.tt-depending-field-values').find('.tt-select2.select2-hidden-accessible:not([name="integrity_depending_field"])').val(null).trigger('change.select2');
        jQuery.each($(this).parents('form').find('.tt-depending-field-values').find('.tt-date-dropdown'), function (i, val) {
            utils.setValueForInputWithDropDownField($(val).parent(), 'years', true);
        });

        var table_type = '';
        var table = '';

        if ($(this)[0].name === 'integrity_dependency_frequency') {
            setIntegrityDependencyFieldsOfDepValue($(this).parents('.modal-content').find('[name="integrity_depending_field"]'));
            showIntegrityDependencySpecificFieldsOfDepValue($(this).parents('.modal-content').find('[name="integrity_depending_field"]'));

            if (!utils.isUndefined($(this).parents('.modal-content').find('[name="integrity_depending_field"]').select2('val')) && $(this).parents('.modal-content').find('[name="integrity_depending_field"]').select2('val') !== '') {
                table_type = $(this).parents('.modal-content').find('[name="integrity_depending_field"]').select2('data')[0].tableType;
                table = $(this).parents('.modal-content').find('[name="integrity_depending_field"]').select2('data')[0].table;
            }
        } else {
            setIntegrityDependencyFieldsOfDepValue(this);
            showIntegrityDependencySpecificFieldsOfDepValue(this);

            if (!utils.isUndefined($(this).select2('val')) && $(this).select2('val') !== '') {
                table_type = $(this).select2('data')[0].tableType;
                table = $(this).select2('data')[0].table;
            }
        }

        var tableTypeName = '';
        if (table_type === 'master_table' || table_type === 'master_facility_table') {
            tableTypeName = 'master';
        } else if (table_type === 'course_table' || table_type === 'course_facility_table') {
            tableTypeName = 'course';
        } else if (table_type === 'period_table' || table_type === 'period_facility_table') {
            tableTypeName = 'period_' + table;
        }

        setIntegrityFieldSelection('integrity_depending_field_value_from_date_field', 'date_fields_' + tableTypeName, 'tt-integrity-field validation-group-norm-date-from', $(this).parents('form'));
        setIntegrityFieldSelection('integrity_depending_field_value_till_date_field', 'date_fields_' + tableTypeName, 'tt-integrity-field validation-group-norm-date-till tt-disabled-integrity-select2', $(this).parents('form'));

        setIntegrityFieldSelection('integrity_depending_field_value_from_field', 'number_fields_' + tableTypeName, 'tt-integrity-field tt-integrity-deviation-value-field validation-depending-dependency-group-range-input-from', $(this).parents('form'));
        setIntegrityFieldSelection('integrity_depending_field_value_till_field', 'number_fields_' + tableTypeName, 'tt-integrity-field tt-integrity-deviation-value-field tt-disabled-integrity-select2 validation-depending-dependency-group-range-input-till', $(this).parents('form'));
    });

    // Integritäten - Anhaken von 'Wert vorhanden' (Abhängigkeit)
    $('body').on('change', '.tt-integrity-existing-value', function (e) {
        if ($(this)[0].checked) {

            // Werte zurücksetzen
            $(this).parents('form').find('.tt-field-values').find('input[type="hidden"]').val("");
            $(this).parents('form').find('.tt-field-values').find('input:not([type="radio"])').val("");
            if ($(this).parents('form').find('.tt-field-values').find('.datepicker').length) {
                $(this).parents('form').find('.tt-field-values').find('.datepicker').data('picker').setDate(null);
            }
            $(this).parents('form').find('.tt-field-values').find('[type="radio"],[type="checkbox"]:not([name="integrity_existing_value"])').prop('checked', false);
            $(this).parents('form').find('.tt-field-values').find('.tt-select2.select2-hidden-accessible').val(null).trigger('change.select2');
            jQuery.each($(this).parents('form').find('.tt-field-values').find('.tt-date-dropdown'), function (i, val) {
                utils.setValueForInputWithDropDownField($(val).parent(), 'years', true);
            });
        }

        setIntegrityDependencyFieldsOfValue(this);
    });

    // Integritäten - Anhaken von 'Wert nicht vorhanden' (Abhängigkeit)
    $('body').on('change', '.tt-integrity-not-existing-value', function (e) {
        if ($(this)[0].checked) {

            // Werte zurücksetzen
            $(this).parents('form').find('.tt-field-values').find('input[type="hidden"]').val("");
            $(this).parents('form').find('.tt-field-values').find('input:not([type="radio"])').val("");
            if ($(this).parents('form').find('.tt-field-values').find('.datepicker').length) {
                $(this).parents('form').find('.tt-field-values').find('.datepicker').data('picker').setDate(null);
            }
            $(this).parents('form').find('.tt-field-values').find('[type="radio"],[type="checkbox"]:not([name="integrity_not_existing_value"])').prop('checked', false);
            $(this).parents('form').find('.tt-field-values').find('.tt-select2.select2-hidden-accessible').val(null).trigger('change.select2');
            jQuery.each($(this).parents('form').find('.tt-field-values').find('.tt-date-dropdown'), function (i, val) {
                utils.setValueForInputWithDropDownField($(val).parent(), 'years', true);
            });
        }

        setIntegrityDependencyFieldsOfValue(this);
    });

    // Integritäten - Anhaken von 'Wert vorhanden' des abhängigen Feldes (Abhängigkeit)
    $('body').on('change', '.tt-integrity-existing-depending-value', function (e) {
        if ($(this)[0].checked) {

            // Werte zurücksetzen
            $(this).parents('form').find('.tt-depending-field-values').find('input[type="hidden"]').val("");
            $(this).parents('form').find('.tt-depending-field-values').find('input:not([type="radio"])').val("");
            if ($(this).parents('form').find('.tt-depending-field-values').find('.datepicker').length) {
                $(this).parents('form').find('.tt-depending-field-values').find('.datepicker').data('picker').setDate(null);
            }
            $(this).parents('form').find('.tt-depending-field-values').find('[type="radio"]:not([name="integrity_dependency_frequency"]),[type="checkbox"]:not([name="integrity_existing_depending_value"])').prop('checked', false);
            $(this).parents('form').find('.tt-depending-field-values').find('.tt-select2.select2-hidden-accessible').val(null).trigger('change.select2');
            jQuery.each($(this).parents('form').find('.tt-depending-field-values').find('.tt-date-dropdown'), function (i, val) {
                utils.setValueForInputWithDropDownField($(val).parent(), 'years', true);
            });
        }

        setIntegrityDependencyFieldsOfDepValue(this);
    });

    // Integritäten - Anhaken von 'Wert nicht vorhanden' des abhängigen Feldes (Abhängigkeit)
    $('body').on('change', '.tt-integrity-not-existing-depending-value', function (e) {
        if ($(this)[0].checked) {

            // Werte zurücksetzen
            $(this).parents('form').find('.tt-depending-field-values').find('input[type="hidden"]').val("");
            $(this).parents('form').find('.tt-depending-field-values').find('input:not([type="radio"])').val("");
            if ($(this).parents('form').find('.tt-depending-field-values').find('.datepicker').length) {
                $(this).parents('form').find('.tt-depending-field-values').find('.datepicker').data('picker').setDate(null);
            }
            $(this).parents('form').find('.tt-depending-field-values').find('[type="radio"]:not([name="integrity_dependency_frequency"]),[type="checkbox"]:not([name="integrity_not_existing_depending_value"])').prop('checked', false);
            $(this).parents('form').find('.tt-depending-field-values').find('.tt-select2.select2-hidden-accessible').val(null).trigger('change.select2');
            jQuery.each($(this).parents('form').find('.tt-depending-field-values').find('.tt-date-dropdown'), function (i, val) {
                utils.setValueForInputWithDropDownField($(val).parent(), 'years', true);
            });
        }

        setIntegrityDependencyFieldsOfDepValue(this);
    });

    // Integritäten - Ändern von 'Wert (Feld)' (Wertebereich)
    $('body').on('change', '.tt-integrity-deviation-value-field', function (e) {
        var parent_class = '';
        jQuery.each($(this).parents(), function (i, parent) {
            if (parent.classList.length) {
                jQuery.each(parent.classList, function (i, current_class) {
                    if (/^tt-/.test(current_class)) {
                        parent_class = current_class;
                        return false;
                    }
                });
            }
            if (parent_class !== '') {
                return false;
            }
        });

        setIntegrityValueTill(this, '.' + parent_class);
    });

    // Schreibt den eigenen Wert in das angegebene hidden input field.
    $('body').on('change', '.tt-save-in-hidden-input', function (e) {

        var hiddenInputName = $(this).data().hiddenInputName;
        $('#content-detail').find('[name="' + hiddenInputName + '"]').val($(this).val());

        $("#content-detail").find('.tt-check-changes-form').trigger('checkform.areYouSure');
    });

    // Integritäten - Anhaken von Pflichtfeld bei Vollständigkeiten
    $('body').on('change', '[name="completeness_mandatory_field"]', function (e) {

        if ($(this)[0].checked) {
            $(this).parents('form').find('.tt-completeness-frequency-group:not([name="completeness_mandatory_field"])').prop('checked', false);
            $(this).parents('form').find('[name="completeness_optional"]').prop('checked', false);
        }
    });

    // Integritäten - Anhaken von Erhebungsfrequenz bzw. Optional bei Vollständigkeiten
    $('body').on('change', '[name="completeness_optional"],.tt-completeness-frequency-group:not([name="completeness_mandatory_field"])', function (e) {

        if ($(this)[0].checked) {
            $(this).parents('form').find('[name="completeness_mandatory_field"]').prop('checked', false);
        }
    });

    // Integritäten - Validierungsregeln neu setzen und Vordefinierte Vollständigkeit zurücksetzen
    $('body').on('change', '[name="integrity_custom_rule"]', function (e) {

        if (!utils.isUndefined($(this).select2('val')) && $(this).select2('val') !== '') {

            $(this).parents('form').find('[name="integrity_type"]').val(null).trigger('change');

            $(this).parents('form').validate().settings.rules = validator.getRules($(this).parents('form'));
        }
    });

    // Integritäten - Logik-Auswahl für den Bis-Bereich neu setzen
    $('body').on('change', '.tt-integrity-logical-from', function (e) {

        setIntegrityFieldsDependingOnLogicalOperator(this);
    });

    // Integritäten - Bei Änderung der Datenerhebungsart bzw. des Datenfeldes zugeordnete Felder neu befüllen
    $('body').on('change', '[name="integrity_data_collection_type"],[name="integrity_data_view_field"]', function (e) {

        if ($(this).parents('#table_data_views_restrictions_dialog').length === 0 && $(this).parents('#table_data_views_restrictions_create_dialog').length === 0) {

            $(this).parents('form').find('[name="integrity_description"]').val("");
            $(this).parents('form').find('[name="integrity_valid_from"]').data('picker').setDate(null);
            $(this).parents('form').find('[name="integrity_valid_from"]').val('');
            $(this).parents('form').find('[name="integrity_valid_till"]').data('picker').setDate(null);
            $(this).parents('form').find('[name="integrity_valid_till"]').val('');
            $(this).parents('form').find('[name="integrity_type"]').val(null).trigger('change.select2');
            $(this).parents('form').find('[name="integrity_custom_rule"]').val(null).trigger('change.select2');
            $(this).parents('form').find('[name="integrity_type"]').find('.tt-select2').removeAttr('disabled');
            $(this).parents('form').find('[name="integrity_custom_rule"]').find('.tt-select2').removeAttr('disabled');

            $(this).parents('form').find('.tt-select-integrity-type').trigger('change');
        }

        var fieldTableType = '';
        if ($(this)[0].name === 'integrity_data_view_field') {
            if (!utils.isUndefined($(this).select2('val')) && $(this).select2('val') !== '') {
                $('#table_collection_type_integrities_dialog').find('[name="control_type"]').val($(this).select2('data')[0].controlType);
                $('#table_collection_type_integrities_dialog').find('[name="data_type"]').val($(this).select2('data')[0].dataType);
            } else {
                $('#table_collection_type_integrities_dialog').find('[name="control_type"]').val('');
                $('#table_collection_type_integrities_dialog').find('[name="data_type"]').val('');
            }

            // Auswahllisten neu befüllen
            var control_type = '';
            var data_type = '';
            var control_type_values = '';
            var units = '';
            var is_additional_field = false;
            var format_fields = '';
            var table_type = '';
            var match_field = '';
            var table = '';

            if (!utils.isUndefined($(this).select2('val')) && $(this).select2('val') !== '') {
                control_type = $(this).select2('data')[0].controlType;
                data_type = $(this).select2('data')[0].dataType;
                control_type_values = $(this).select2('data')[0].controlValues;
                units = $(this).select2('data')[0].units;
                if ($(this).select2('data')[0].additionalField === '1') {
                    is_additional_field = true;
                }
                format_fields = $(this).select2('data')[0].formatFields.split('|');
                table_type = $(this).select2('data')[0].tableType;
                match_field = $(this).select2('data')[0].matchField;
                table = $(this).select2('data')[0].table;
            }

            if (table_type === 'master_table' || table_type === 'master_facility_table') {
                fieldTableType = 'master';
            } else if (table_type === 'course_table' || table_type === 'course_facility_table') {
                fieldTableType = 'course';
            } else if (table_type === 'period_table' || table_type === 'period_facility_table') {
                fieldTableType = 'period_' + table;
            }

            if (table_type === 'period_table' || table_type === 'period_facility_table') {
                $('[name="completeness_frequency"][value="every_examination"]').parent().addClass('hide');
                $('[name="completeness_frequency"][value="every_time"]').parent().removeClass('hide');
                $('[name="completeness_frequency"][value="quarterly"]').parent().addClass('hide');
                $('[name="completeness_frequency"][value="monthly"]').parent().addClass('hide');
                $('[name="completeness_frequency"][value="annually"]').parent().addClass('hide');
                $('[name="completeness_frequency"][value="annually_calendar"]').parent().addClass('hide');
            } else {
                $('[name="completeness_frequency"][value="every_examination"]').parent().removeClass('hide');
                $('[name="completeness_frequency"][value="every_time"]').parent().addClass('hide');
                $('[name="completeness_frequency"][value="quarterly"]').parent().removeClass('hide');
                $('[name="completeness_frequency"][value="monthly"]').parent().removeClass('hide');
                $('[name="completeness_frequency"][value="annually"]').parent().removeClass('hide');
                $('[name="completeness_frequency"][value="annually_calendar"]').parent().removeClass('hide');
            }

            loadIntegrityComboboxValues(control_type, data_type, table_type, control_type_values, units, is_additional_field, format_fields, match_field, false)
        } else {
            var table_type = $(this).parents('.tt-content-dialog').find('[name="table_type"]').val();
            var table = $(this).parents('.tt-content-dialog').find('[name="table"]').val();

            if (table_type === 'master_table' || table_type === 'master_facility_table') {
                fieldTableType = 'master';
            } else if (table_type === 'course_table' || table_type === 'course_facility_table') {
                fieldTableType = 'course';
            } else if (table_type === 'period_table' || table_type === 'period_facility_table') {
                fieldTableType = 'period_' + table;
            }
        }

        setIntegrityComboboxItems($(this).parents('form'), fieldTableType, false);
    });

    $('body').on('change', '.tt-integrity-deviation-value-field', function (e) {

        var units = '';
        if (!utils.isUndefined($(this).select2('val')) && $(this).select2('val') !== '') {
            units = $(this).select2('data')[0].units;
        }

        if (!utils.isUndefined(units) && units !== '') {

            var range = $(this).attr('data-range');
            var name= $(this)[0].name;

            var data_units = [];
            var lab_units_input = units.split('|');
            jQuery.each(lab_units_input, function (i, val) {

                var lab_unit = val.split('#');
                data_units.push({id: lab_unit[0], text: lab_unit[0]});
            });

            validator.reinitializeSelect2($('.' + name + '_unit_2'), 'input-sm tt-select2', 'data-range="' + range + '"', data_units, false);

        } else {

            validator.reinitializeSelect2($('.' + name + '_unit_2'), 'input-sm tt-select2', 'data-range="' + range + '"', [], false);
        }
    });

    // Integritäten - Einheit für den Von- bzw. Bis-Bereich gleich setzen
    $('body').on('click', '.tt-select-integrity-unit-value', function (e) {
        e.preventDefault();

        // if ($(this).parent().hasClass('active')) {
        //  return;
        // }

        utils.setInputDropDownValue($(this).parents('.tt-field-input-numeric,.tt-depending-field-input-numeric,.tt-range-input,.tt-deviation-input').find('.tt-select-integrity-unit-value[data-format-value="' + $(this).data('formatValue') + '"]')[0], true);
        utils.setInputDropDownValue($(this).parents('.tt-field-input-numeric,.tt-depending-field-input-numeric,.tt-range-input,.tt-deviation-input').find('.tt-select-integrity-unit-value[data-format-value="' + $(this).data('formatValue') + '"]')[1], true);

        if ($(this).parents('.display-flex').find('.datepicker,.treelist-input').length > 0) {
            validator.triggerValidation($(this).parents('.display-flex').find('.datepicker,.treelist-input')[0], true, false);
        }
    });

    // Dialog anzeigen
    $('body').on('show.bs.modal', '.tt-content-dialog', function (e) {

        // Neue Integrität
        if ($(this)[0].id === "table_data_views_integrities_create_dialog" || $(this)[0].id === "table_data_views_integrities_dialog"
            || ($(this)[0].id === "table_collection_type_integrities_dialog" && $('#table_collection_type_integrities_form').find('[name="selected_id"]').val() === '')) {

            showIntegritySpecificFieldsOfValue($(this).find('[name="integrity_type"]'));
            showIntegrityDependencySpecificFieldsOfDepValue($(this).find('[name="integrity_depending_field"]'));
            setIntegrityDependencyFieldsOfValue($(this).find('[name="integrity_existing_value"]'));
            setIntegrityDependencyFieldsOfValue($(this).find('[name="integrity_not_existing_value"]'));
            setIntegrityDependencyFieldsOfDepValue($(this).find('[name="integrity_existing_depending_value"]'));
            setIntegrityDependencyFieldsOfDepValue($(this).find('[name="integrity_not_existing_depending_value"]'));

            $(this).find('input:not([type="hidden"],[type="radio"])').val("");
            $(this).find('input').removeAttr('disabled');
            $(this).find('input').parent().removeClass('state-disabled');
            $(this).find('.dropdown-toggle').prop("disabled", "");
            $(this).find('[type="radio"],[type="checkbox"]').prop('checked', false);
            $(this).find('.tt-select2.select2-hidden-accessible').val(null).trigger('change.select2');
            $(this).find('.tt-select2').removeAttr('disabled');
            jQuery.each($(this).find('.tt-date-dropdown'), function (i, val) {
                utils.setValueForInputWithDropDownField($(val).parent(), 'years', true);
            });
        }

        // Neue Einschränkung der Abfragen
        if ($(this)[0].id === "table_monitoring_restrictions_dialog" && $('#table_monitoring_restrictions_form').parents('.tt-content-datatable').find('[name="selected_monitoring_nestable_id"]').val() === '') {

            $(this).find('[name="control_type"]').val("");
            $(this).find('[name="data_type"]').val("");

            monitoring.showMonitoringRestrictionSpecificFieldsOfValue($(this).find('[name="monitoring_restriction_data_view_field"]'));
            monitoring.setMonitoringRestrictionDependingFieldsOfValue($(this).find('[name="monitoring_restriction_existing_value"]'));
            monitoring.setMonitoringRestrictionDependingFieldsOfValue($(this).find('[name="monitoring_restriction_not_existing_value"]'));

            $(this).find('input:not([type="hidden"],[type="radio"])').val("");
            $(this).find('input').removeAttr('disabled');
            $(this).find('input').parent().removeClass('state-disabled');
            $(this).find('.dropdown-toggle').prop("disabled", "");
            $(this).find('[type="radio"],[type="checkbox"]').prop('checked', false);
            $(this).find('.tt-select2.select2-hidden-accessible').val(null).trigger('change.select2');
            $(this).find('.tt-select2').removeAttr('disabled');
            jQuery.each($(this).find('.tt-date-dropdown'), function (i, val) {
                utils.setValueForInputWithDropDownField($(val).parent(), 'years', true);
            });
        }

        if ($(this)[0].id === "table_data_views_integrities_create_dialog" || $(this)[0].id === "table_data_views_integrities_dialog") {

            $(this).find('.tt-integrity-data-collection-type-row').removeClass('hide');
            $(this).find('.tt-integrity-data-view-field-row').addClass('hide');

            $(this).find('[name="control_type"]').val($('#table_data_views_integrities_dialog').find('[name="control_type"]').val());
            $(this).find('[name="data_type"]').val($('#table_data_views_integrities_dialog').find('[name="data_type"]').val());
            $(this).find('[name="parent_tab"]').val($('#table_data_views_integrities_dialog').find('[name="parent_tab"]').val());
            $(this).find('[name="data_view_id"]').val($('#table_data_views_integrities_dialog').find('[name="data_view_id"]').val());
            $(this).find('[name="data_view_name"]').val($('#table_data_views_integrities_dialog').find('[name="data_view_name"]').val());
            $(this).find('[name="table_type"]').val($('#table_data_views_integrities_dialog').find('[name="table_type"]').val());
            $(this).find('[name="table"]').val($('#table_data_views_integrities_dialog').find('[name="table"]').val());
            $(this).find('[name="parent_data_view_id_if_item_is_in_accordion_or_list"]').val($('#table_data_views_integrities_dialog').find('[name="parent_data_view_id_if_item_is_in_accordion_or_list"]').val());

        } else if ($(this)[0].id === "table_collection_type_integrities_dialog") {

            $(this).find('.tt-integrity-data-view-field-row').removeClass('hide');
            $(this).find('.tt-integrity-data-collection-type-row').addClass('hide');

        } else if ($(this)[0].id === "table_data_views_restrictions_create_dialog" || $(this)[0].id === "table_data_views_restrictions_dialog") {

            $(this).find('.tt-select-integrity-type').val('restriction').trigger('change.select2');

        }
    });

    // Dialog schließen
    $('body').on('hide.bs.modal', '.tt-content-dialog', function (e) {
        if (!utils.isUndefined($(this).find('form')[0])) {

            // Diese Forms haben keinen Submit-Button, lediglich einen Schließen-Button (Ähnlich dem Abbrechen-Button)
            if ($(this).find('form')[0].id === "table_data_views_integrities_form") {

                var contentString = '';
                var editIntegrityButtonId = $(this).find('[name="button_id"]').val();
                var editIntegrityButton = $("#content-detail").find('#' + editIntegrityButtonId);
                var tr = $("#content-detail").find('#' + editIntegrityButtonId).parents('tr');
                var parent_id = tr[0].getAttribute('data-tt-parent-id');

                $('#table_data_view_properties').find('.tt-integrity' + editIntegrityButtonId.replace('button_edit_integrity_rules', '')).remove();

                var default_unit_string = '';
                jQuery.each($('#table_data_views_integrities').dataTable().fnGetNodes(), function (i, modal_val) {
                    var modal_data = $('#table_data_views_integrities').dataTable().fnGetData(i);

                    if (i > 0) {
                        contentString = contentString + '|';
                    }

                    var html = '<tr class="tt-integrity' + editIntegrityButtonId.replace('button_edit_integrity_rules', '') + '" data-tt-id="integrities_' + modal_data[0] + '" data-tt-parent-id="' + parent_id + '" ' + 'data-name="' + modal_data[1] + '">';
                    html += '<td colspan="3" style="width:100%">- ' + modal_data[1] + ': ' + modal_data[2] + ' (' + modal_data[3] + ')</i>';
                    html += '</td>';
                    html += '</tr>';

                    $("#table_data_view_properties").treetable("loadBranch", $("#table_data_view_properties").treetable("node", tr[0].getAttribute('data-tt-id')), html);

                    contentString += modal_data[0] + '#' + modal_data[1] + '#' + modal_data[2] + '#' + modal_data[4] + '#' + modal_data[5] + '#' + modal_data[6] + '#' + modal_data[7]
                        + '#' + modal_data[8] + '#' + modal_data[9] + '#' + modal_data[10] + '#' + modal_data[11] + '#' + modal_data[12] + '#' + modal_data[13] + '#' + modal_data[14] + '#' + modal_data[15]
                        + '#' + modal_data[16] + '#' + modal_data[17] + '#' + modal_data[18] + '#' + modal_data[19] + '#' + modal_data[20] + '#' + modal_data[21] + '#' + modal_data[22] + '#' + modal_data[23]
                        + '#' + modal_data[24] + '#' + modal_data[25] + '#' + modal_data[26] + '#' + modal_data[27] + '#' + modal_data[28] + '#' + modal_data[29] + '#' + modal_data[30] + '#' + modal_data[31]
                        + '#' + modal_data[32] + '#' + modal_data[33] + '#' + modal_data[34] + '#' + modal_data[35] + '#' + modal_data[36] + '#' + modal_data[37] + '#' + modal_data[38] + '#' + modal_data[39]
                        + '#' + modal_data[40] + '#' + modal_data[41] + '#' + modal_data[42] + '#' + modal_data[43] + '#' + modal_data[44] + '#' + modal_data[45] + '#' + modal_data[46] + '#' + modal_data[47]
                        + '#' + modal_data[48] + '#' + modal_data[49] + '#' + modal_data[50] + '#' + modal_data[51] + '#' + modal_data[52] + '#' + modal_data[53] + '#' + modal_data[54] + '#' + modal_data[55]
                        + '#' + modal_data[56] + '#' + modal_data[57] + '#' + modal_data[58] + '#' + modal_data[59] + '#' + modal_data[60] + '#' + modal_data[61] + '#' + modal_data[62] + '#' + modal_data[63]
                        + '#' + modal_data[64] + '#' + modal_data[65] + '#' + modal_data[66] + '#' + modal_data[67] + '#' + modal_data[68] + '#' + modal_data[69] + '#' + modal_data[70] + '#' + modal_data[71];
                });

                if (editIntegrityButton.length) {
                    var dialogId = $(editIntegrityButton).attr('href');
                    var input = $("#content-detail").find('[name="' + editIntegrityButtonId.substring(editIntegrityButtonId.indexOf('_') + 1) + '"]');
                    input.val(contentString);
                }

                $("#content-detail").find('form').trigger('checkform.areYouSure');

            } else if ($(this).find('form')[0].id === "table_data_views_restrictions_form") {

                var contentString = '';
                var editIntegrityButtonId = $(this).find('[name="button_id"]').val();
                var editIntegrityButton = $("#content-detail").find('#' + editIntegrityButtonId);
                var tr = $("#content-detail").find('#' + editIntegrityButtonId).parents('tr');
                var parent_id = tr[0].getAttribute('data-tt-parent-id');

                $('#table_data_view_properties').find('.tt-restriction').remove();

                var default_unit_string = '';
                jQuery.each($('#table_data_views_restrictions').dataTable().fnGetNodes(), function (i, modal_val) {
                    var modal_data = $('#table_data_views_restrictions').dataTable().fnGetData(i);

                    if (i > 0) {
                        contentString = contentString + '|';
                    }

                    var html = '<tr class="tt-restriction" data-tt-id="integrities_' + modal_data[0] + '" data-tt-parent-id="' + parent_id + '" ' + 'data-name="' + modal_data[1] + '">';
                    html += '<td style="width:30%"></td>';
                    html += '<td colspan="2" style="width:70%">- ' + modal_data[1] + ': ' + modal_data[2] + '</i>';
                    html += '</td>';
                    html += '</tr>';

                    $("#table_data_view_properties").treetable("loadBranch", $("#table_data_view_properties").treetable("node", tr[0].getAttribute('data-tt-id')), html);

                    contentString += modal_data[0] + '#' + modal_data[1] + '#' + modal_data[2] + '#' + modal_data[4] + '#' + modal_data[5] + '#' + modal_data[6] + '#' + modal_data[7]
                        + '#' + modal_data[8] + '#' + modal_data[9] + '#' + modal_data[10] + '#' + modal_data[11] + '#' + modal_data[12] + '#' + modal_data[13] + '#' + modal_data[14] + '#' + modal_data[15]
                        + '#' + modal_data[16] + '#' + modal_data[17] + '#' + modal_data[18] + '#' + modal_data[19] + '#' + modal_data[20] + '#' + modal_data[21] + '#' + modal_data[22] + '#' + modal_data[23]
                        + '#' + modal_data[24] + '#' + modal_data[25] + '#' + modal_data[26] + '#' + modal_data[27] + '#' + modal_data[28] + '#' + modal_data[29] + '#' + modal_data[30] + '#' + modal_data[31]
                        + '#' + modal_data[32] + '#' + modal_data[33] + '#' + modal_data[34] + '#' + modal_data[35] + '#' + modal_data[36] + '#' + modal_data[37] + '#' + modal_data[38] + '#' + modal_data[39]
                        + '#' + modal_data[40] + '#' + modal_data[41] + '#' + modal_data[42] + '#' + modal_data[43] + '#' + modal_data[44] + '#' + modal_data[45] + '#' + modal_data[46] + '#' + modal_data[47]
                        + '#' + modal_data[48] + '#' + modal_data[49] + '#' + modal_data[50] + '#' + modal_data[51] + '#' + modal_data[52] + '#' + modal_data[53] + '#' + modal_data[54] + '#' + modal_data[55]
                        + '#' + modal_data[56] + '#' + modal_data[57] + '#' + modal_data[58] + '#' + modal_data[59] + '#' + modal_data[60] + '#' + modal_data[61] + '#' + modal_data[62] + '#' + modal_data[63]
                        + '#' + modal_data[64] + '#' + modal_data[65] + '#' + modal_data[66] + '#' + modal_data[67] + '#' + modal_data[68] + '#' + modal_data[69] + '#' + modal_data[70] + '#' + modal_data[71];
                });

                if (editIntegrityButton.length) {
                    var dialogId = $(editIntegrityButton).attr('href');
                    var input = $("#content-detail").find('[name="' + editIntegrityButtonId.substring(editIntegrityButtonId.indexOf('_') + 1) + '"]');
                    input.val(contentString);
                }

                $("#content-detail").find('form').trigger('checkform.areYouSure');

            } else if ($(this).find('form')[0].id === "table_collection_type_integrities_form") {

                $(this).find('.tripletrax-modal-title').text(trans('tripletrax.new_integrity'));

            }

            // Form zurücksetzen
            resetForm(this);
        }
    });
}

function setIntegritySavedValues(element, aData) {
    // Alle Felder zurücksetzen
    $(element).parents('.modal-content').find('input:not([type="hidden"],[type="radio"])').val("");
    $(element).parents('.modal-content').find('input').removeAttr('disabled');
    $(element).parents('.modal-content').find('input').parent().removeClass('state-disabled');
    $(element).parents('.modal-content').find('.dropdown-toggle').prop("disabled", "");
    $(element).parents('.modal-content').find('[type="radio"],[type="checkbox"]').prop('checked', false);
    $(element).parents('.modal-content').find('.tt-select2.select2-hidden-accessible').val(null).trigger('change.select2');
    $(element).parents('.modal-content').find('.tt-select2').removeAttr('disabled');
    jQuery.each($(element).parents('.modal-content').find('.tt-date-dropdown'), function (i, val) {
        utils.setValueForInputWithDropDownField($(val).parent(), 'years', true);
    });

    // Allgemeine Angaben
    $(element).parents('.modal-content').find('[name="selected_id"]').val(aData[0]);
    $(element).parents('.modal-content').find('[name="integrity_data_collection_type"]').val(aData[6]).trigger('change.select2');
    if (!$(element).parents('.modal-content').find('[name="table"]').length && !$(element).parents('.modal-content').find('[name="table"]').length) {
        // Anzeige bei Projekte / Studien / Fragebögen
        $(element).parents('.modal-content').find('[name="integrity_data_view_field"]').val(aData[6] + '|' + aData[71]).trigger('change');

        var table_type = '';
        var table = '';

        if (!utils.isUndefined($(element).parents('.modal-content').find('[name="integrity_data_view_field"]').select2('val')) && $(element).parents('.modal-content').find('[name="integrity_data_view_field"]').select2('val') !== '') {
            table_type = $(element).parents('.modal-content').find('[name="integrity_data_view_field"]').select2('data')[0].tableType;
            table = $(element).parents('.modal-content').find('[name="integrity_data_view_field"]').select2('data')[0].table;
        }
    } else {
        // Anzeige bei Ansichten und Datenfelder
        var table_type = $(element).parents('.modal-content').find('[name="table_type"]').val();
        var table = $(element).parents('.modal-content').find('[name="table"]').val();
    }

    var fieldTableType = '';
    if (table_type === 'master_table' || table_type === 'master_facility_table') {
        fieldTableType = 'master';
    } else if (table_type === 'course_table' || table_type === 'course_facility_table') {
        fieldTableType = 'course';
    } else if (table_type === 'period_table' || table_type === 'period_facility_table') {
        fieldTableType = 'period_' + table;
    }

    setIntegrityComboboxItems($(element).parents('.modal-content').find('form'), fieldTableType, false);
    $(element).parents('.modal-content').find('[name="integrity_description"]').val(aData[2].replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>'));
	if (utils.isUndefined(aData[65]) || aData[65] === '') {
		$(element).parents('.modal-content').find('[name="integrity_valid_from"]').data('picker').setDate(null);
	} else {
		$(element).parents('.modal-content').find('[name="integrity_valid_from"]').data('picker').setDate(aData[65]);
	}
	if (utils.isUndefined(aData[66]) || aData[66] === '') {
		$(element).parents('.modal-content').find('[name="integrity_valid_till"]').data('picker').setDate(null);
	} else {
		$(element).parents('.modal-content').find('[name="integrity_valid_till"]').data('picker').setDate(aData[66]);
	}
    $(element).parents('.modal-content').find('[name="integrity_type"]').val(aData[4]).trigger('change.select2');
    $(element).parents('.modal-content').find('[name="integrity_custom_rule"]').val(aData[8]).trigger('change.select2');
    showIntegritySpecificFieldsOfValue($(element).parents('.modal-content').find('[name="integrity_type"]'));
    if (aData[5] !== '') {
        $(element).parents('.modal-content').find('[name="integrity_integritytype"][value="' + aData[5] + '"]')[0].checked = true;
    }
    if (aData[7] !== '') {
        $(element).parents('.modal-content').find('[name="integrity_gender"][value="' + aData[7] + '"]')[0].checked = true;
    }

    // Alter von
    if (aData[9] !== '0') {
        if (aData[11] === '+') {
            $(element).parents('.modal-content').find('[name="integrity_age_from_plus_minus"]')[0].checked = false;
        } else {
            $(element).parents('.modal-content').find('[name="integrity_age_from_plus_minus"]')[0].checked = true;
        }
        $(element).parents('.modal-content').find('[name="integrity_age_from_field"]').val(aData[9] + '|' + aData[10]).trigger('change.select2');
        $(element).parents('.modal-content').find('[name="integrity_age_from_range"]').val(aData[12]);
        utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_age_from_range"]').parent(), aData[13], true);
    } else {
        $(element).parents('.modal-content').find('[name="integrity_age_from_field"]').val(null).trigger('change.select2');
    }

    // Alter bis
    if (aData[14] !== '0') {
        if (aData[16] === '+') {
            $(element).parents('.modal-content').find('[name="integrity_age_till_plus_minus"]')[0].checked = false;
        } else {
            $(element).parents('.modal-content').find('[name="integrity_age_till_plus_minus"]')[0].checked = true;
        }
        $(element).parents('.modal-content').find('[name="integrity_age_till_field"]').val(aData[14] + '|' + aData[15]).trigger('change.select2');
        $(element).parents('.modal-content').find('[name="integrity_age_till_range"]').val(aData[17]);
        utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_age_till_range"]').parent(), aData[18], true);
    } else {
        $(element).parents('.modal-content').find('[name="integrity_age_till_field"]').val(null).trigger('change.select2');
    }

	if (utils.isUndefined(aData[71]) || aData[71] === '') {
		$(element).parents('.modal-content').find('[name="date_range_integrity_id"]').val('');
	} else {
		$(element).parents('.modal-content').find('[name="date_range_integrity_id"]').val(aData[71]);
	}

    var control_type = $(element).parents('.modal-content').find('[name="control_type"]').val();
    var data_type = $(element).parents('.modal-content').find('[name="data_type"]').val();

    if (aData[4] === 'completeness') {

        if (aData[20] !== '') {
            $(element).parents('.modal-content').find('[name="completeness_frequency"][value="' + aData[20] + '"]')[0].checked = true;
        }
        if (aData[21] === '1') {
            $(element).parents('.modal-content').find('[name="completeness_optional"]')[0].checked = true;
        }
        if (aData[64] === '1') {
            $(element).parents('.modal-content').find('[name="completeness_mandatory_field"]')[0].checked = true;
        }
        $(element).parents('.modal-content').find('[name="completeness_range_of_values"]').val(aData[37].split('$')).trigger('change.select2');

    } else if (aData[4] === 'range') {

        if (control_type === 'input' || control_type === 'input_with_additionalfield' || control_type === 'textarea') {

            $(element).parents('.modal-content').find('[name="integrity_logical_from_field"]').val($("<textarea/>").html(aData[23]).text()).trigger('change.select2');

            if (aData[23] !== '') {
                $(element).parents('.modal-content').find('[name="integrity_value_from"]').val(utils.numberToString(parseFloat(aData[24])));
                utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_value_from"]').parent(), aData[22], true);
                if (aData[25] !== '0') {
                    $(element).parents('.modal-content').find('[name="integrity_value_from"]').val('');
                    $(element).parents('.modal-content').find('[name="integrity_value_from"]').prop('disabled', 'disabled');
                    $(element).parents('.modal-content').find('[name="integrity_value_from"]').parent().addClass('state-disabled');
                    $(element).parents('.tt-field-input-numeric').find('[name="integrity_value_from_dropdown_toggle"]').prop('disabled', 'disabled');
                    $(element).parents('.modal-content').find('[name="integrity_value_from_field"]').val(aData[25] + '|' + aData[26]).trigger('change');
                    $(element).parents('.modal-content').find('[name="integrity_value_from_field_unit_1"]').val(aData[67]).trigger('change.select2');
                    $(element).parents('.modal-content').find('[name="integrity_value_from_field_unit_2"]').val(aData[68]).trigger('change.select2');
                }
            } else if (aData[30] !== '') {
                utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_value_from"]').parent(), aData[22], true);
            }

            if (aData[30] !== '') {
                $(element).parents('.modal-content').find('[name="integrity_value_till"]').val(utils.numberToString(parseFloat(aData[31])));
                utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_value_till"]').parent(), aData[22], true);
                if (aData[32] !== '0') {
                    $(element).parents('.modal-content').find('[name="integrity_value_till"]').val('');
                    $(element).parents('.modal-content').find('[name="integrity_value_till"]').prop('disabled', 'disabled');
                    $(element).parents('.modal-content').find('[name="integrity_value_till"]').parent().addClass('state-disabled');
                    $(element).parents('.tt-field-input-numeric').find('[name="integrity_value_till_dropdown_toggle"]').prop('disabled', 'disabled');
                    $(element).parents('.modal-content').find('[name="integrity_value_till_field"]').val(aData[32] + '|' + aData[33]).trigger('change');
                    $(element).parents('.modal-content').find('[name="integrity_value_till_field_unit_1"]').val(aData[69]).trigger('change.select2');
                    $(element).parents('.modal-content').find('[name="integrity_value_till_field_unit_2"]').val(aData[70]).trigger('change.select2');
                }
            } else if (aData[23] !== '') {
                utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_value_till"]').parent(), aData[22], true);
            }

            setIntegrityFieldsDependingOnLogicalOperator($(element).parents('.modal-content').find('[name="integrity_logical_from_field"]'));
            $(element).parents('.modal-content').find('[name="integrity_logical_till_field"]').val($("<textarea/>").html(aData[30]).text()).trigger('change.select2');

        } else if (control_type === 'date_panel' || control_type === 'date_range') {

            $(element).parents('.modal-content').find('[name="integrity_logical_from_date_field"]').val($("<textarea/>").html(aData[23]).text()).trigger('change.select2');
            if (aData[25] !== '0') {
                if (aData[27] === '+') {
                    $(element).parents('.modal-content').find('[name="integrity_value_from_plus_minus"]')[0].checked = false;
                } else {
                    $(element).parents('.modal-content').find('[name="integrity_value_from_plus_minus"]')[0].checked = true;
                }
                $(element).parents('.modal-content').find('[name="integrity_value_from_date_field"]').val(aData[25] + '|' + aData[26]).trigger('change.select2');
                $(element).parents('.modal-content').find('[name="integrity_value_from_date_range"]').val(aData[28]);
                utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_value_from_date_range"]').parent(), aData[29], true);

            }

            if (aData[32] !== '0') {
                if (aData[34] === '+') {
                    $(element).parents('.modal-content').find('[name="integrity_value_till_plus_minus"]')[0].checked = false;
                } else {
                    $(element).parents('.modal-content').find('[name="integrity_value_till_plus_minus"]')[0].checked = true;
                }
                $(element).parents('.modal-content').find('[name="integrity_value_till_date_field"]').val(aData[32] + '|' + aData[33]).trigger('change.select2');
                $(element).parents('.modal-content').find('[name="integrity_value_till_date_range"]').val(aData[35]);
                utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_value_till_date_range"]').parent(), aData[36], true);

            }

            setIntegrityFieldsDependingOnLogicalOperator($(element).parents('.modal-content').find('[name="integrity_logical_from_date_field"]'));
            $(element).parents('.modal-content').find('[name="integrity_logical_till_date_field"]').val($("<textarea/>").html(aData[30]).text()).trigger('change.select2');

        } else {

            $(element).parents('.modal-content').find('[name="integrity_control_type"]').val(aData[37].split('$')).trigger('change.select2');

        }

    } else if (aData[4] === 'deviation' && (data_type === 'integer' || data_type === 'decimal')) {

        if ($(element).parents('.modal-content').find('[name="integrity_deviation_percentage_value"][value="' + aData[38] + '"]').length) {
            $(element).parents('.modal-content').find('[name="integrity_deviation_percentage_value"][value="' + aData[38] + '"]')[0].checked = true;
        }
        if (aData[39] !== '' && aData[39] !== '-1') {
            $(element).parents('.modal-content').find('[name="integrity_deviation_down"]').val(aData[39]);
            utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_deviation_down"]').parent(), aData[22], true);
            if (aData[40] != '0') {
                $(element).parents('.modal-content').find('[name="integrity_period_down"]').val(aData[40]);
            }
            utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_period_down"]').parent(), aData[41], true);
        } else if (aData[42] !== '' && aData[42] !== '-1') {
            utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_deviation_up"]').parent(), aData[22], true);
        }

        if (aData[42] !== '' && aData[42] !== '-1') {
            $(element).parents('.modal-content').find('[name="integrity_deviation_up"]').val(aData[42]);
            utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_deviation_up"]').parent(), aData[22], true);
            if (aData[43] != '0') {
                $(element).parents('.modal-content').find('[name="integrity_period_up"]').val(aData[43]);
            }
            utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_period_up"]').parent(), aData[44], true);
        } else if (aData[39] !== '' && aData[39] !== '-1') {
            utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_deviation_up"]').parent(), aData[22], true);
        }

    } else if (aData[4] === 'dependency') {

        if (aData[19] === 'existing') {
            $(element).parents('.modal-content').find('[name="integrity_existing_value"]')[0].checked = true;
            $(element).parents('.modal-content').find('[name="integrity_not_existing_value"]')[0].checked = false;
            setIntegrityDependencyFieldsOfValue($(element).parents('.modal-content').find('[name="integrity_existing_value"]'));

        } else if (aData[19] === 'not_existing') {
            $(element).parents('.modal-content').find('[name="integrity_existing_value"]')[0].checked = false;
            $(element).parents('.modal-content').find('[name="integrity_not_existing_value"]')[0].checked = true;
            setIntegrityDependencyFieldsOfValue($(element).parents('.modal-content').find('[name="integrity_not_existing_value"]'));

        } else {

            if (control_type === 'input' || control_type === 'input_with_additionalfield' || control_type === 'textarea') {
                if (data_type === 'integer' || data_type === 'decimal') {

                    $(element).parents('.modal-content').find('[name="integrity_field_logical_from_field"]').val($("<textarea/>").html(aData[23]).text()).trigger('change.select2');

                    if (aData[23] !== '') {
                        $(element).parents('.modal-content').find('[name="integrity_field_value_from"]').val(utils.numberToString(parseFloat(aData[24])));
                        utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_field_value_from"]').parent(), aData[22], true);
                        if (aData[25] !== '0') {
                            $(element).parents('.modal-content').find('[name="integrity_field_value_from"]').val('');
                            $(element).parents('.modal-content').find('[name="integrity_field_value_from"]').prop('disabled', 'disabled');
                            $(element).parents('.modal-content').find('[name="integrity_field_value_from"]').parent().addClass('state-disabled');
                            $(element).parents('.tt-field-input-numeric').find('[name="integrity_field_value_from_dropdown_toggle"]').prop('disabled', 'disabled');
                            $(element).parents('.modal-content').find('[name="integrity_field_value_from_field"]').val(aData[25] + '|' + aData[26]).trigger('change.select2');
                        }
                    } else if (aData[30] !== '') {
                        utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_field_value_from"]').parent(), aData[22], true);
                    }

                    if (aData[30] !== '') {
                        $(element).parents('.modal-content').find('[name="integrity_field_value_till"]').val(utils.numberToString(parseFloat(aData[31])));
                        utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_field_value_till"]').parent(), aData[22], true);
                        if (aData[32] !== '0') {
                            $(element).parents('.modal-content').find('[name="integrity_field_value_till"]').val('');
                            $(element).parents('.modal-content').find('[name="integrity_field_value_till"]').prop('disabled', 'disabled');
                            $(element).parents('.modal-content').find('[name="integrity_field_value_till"]').parent().addClass('state-disabled');
                            $(element).parents('.tt-field-input-numeric').find('[name="integrity_field_value_till_dropdown_toggle"]').prop('disabled', 'disabled');
                            $(element).parents('.modal-content').find('[name="integrity_field_value_till_field"]').val(aData[32] + '|' + aData[33]).trigger('change.select2');
                        }
                    } else if (aData[23] !== '') {
                        utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_field_value_till"]').parent(), aData[22], true);
                    }

                    setIntegrityFieldsDependingOnLogicalOperator($(element).parents('.modal-content').find('[name="integrity_field_logical_from_field"]'));
                    $(element).parents('.modal-content').find('[name="integrity_field_logical_till_field"]').val($("<textarea/>").html(aData[30]).text()).trigger('change.select2');

                }
                else {

                    $(element).parents('.modal-content').find('[name="integrity_field_input"]').val(aData[37]);

                }

            } else if (control_type === 'date_panel' || control_type === 'date_range') {

                $(element).parents('.modal-content').find('[name="integrity_field_logical_from_date_field"]').val($("<textarea/>").html(aData[23]).text()).trigger('change.select2');
                if (aData[25] !== '0') {
                    if (aData[27] === '+') {
                        $(element).parents('.modal-content').find('[name="integrity_field_value_from_plus_minus"]')[0].checked = false;
                    } else {
                        $(element).parents('.modal-content').find('[name="integrity_field_value_from_plus_minus"]')[0].checked = true;
                    }
                    $(element).parents('.modal-content').find('[name="integrity_field_value_from_date_field"]').val(aData[25] + '|' + aData[26]).trigger('change.select2');
                    $(element).parents('.modal-content').find('[name="integrity_field_value_from_date_range"]').val(aData[28]);
                    utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_field_value_from_date_range"]').parent(), aData[29], true);

                }

                if (aData[32] !== '0') {
                    if (aData[34] === '+') {
                        $(element).parents('.modal-content').find('[name="integrity_field_value_till_plus_minus"]')[0].checked = false;
                    } else {
                        $(element).parents('.modal-content').find('[name="integrity_field_value_till_plus_minus"]')[0].checked = true;
                    }
                    $(element).parents('.modal-content').find('[name="integrity_field_value_till_date_field"]').val(aData[32] + '|' + aData[33]).trigger('change.select2');
                    $(element).parents('.modal-content').find('[name="integrity_field_value_till_date_range"]').val(aData[35]);
                    utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_field_value_till_date_range"]').parent(), aData[36], true);

                }

                setIntegrityFieldsDependingOnLogicalOperator($(element).parents('.modal-content').find('[name="integrity_field_logical_from_field"]'));
                $(element).parents('.modal-content').find('[name="integrity_field_logical_till_date_field"]').val($("<textarea/>").html(aData[30]).text()).trigger('change.select2');

            } else {

                $(element).parents('.modal-content').find('[name="integrity_field_list"]').val(aData[37].split('$')).trigger('change.select2');

            }
        }

        $(element).parents('.modal-content').find('[name="integrity_depending_field"]').val(aData[47] + '|' + aData[48]).trigger('change.select2');
        $(element).parents('.modal-content').find('[name="integrity_dependency_frequency"][value="' + aData[20] + '"]')[0].checked = true;
        if (aData[21] === '1') {
            $(element).parents('.modal-content').find('[name="integrity_dependency_optional"]')[0].checked = true;
        }

        showIntegrityDependencySpecificFieldsOfDepValue($(element).parents('.modal-content').find('[name="integrity_depending_field"]')).done(function () {

            if (aData[20] === 'no') {

                if (aData[45] === 'existing') {

                    $(element).parents('.modal-content').find('[name="integrity_existing_depending_value"]')[0].checked = true;
                    $(element).parents('.modal-content').find('[name="integrity_not_existing_depending_value"]')[0].checked = false;
                    setIntegrityDependencyFieldsOfDepValue($(element).parents('.modal-content').find('[name="integrity_existing_depending_value"]'));

                } else if (aData[45] === 'not_existing') {

                    $(element).parents('.modal-content').find('[name="integrity_not_existing_depending_value"]')[0].checked = true;
                    $(element).parents('.modal-content').find('[name="integrity_existing_depending_value"]')[0].checked = false;
                    setIntegrityDependencyFieldsOfDepValue($(element).parents('.modal-content').find('[name="integrity_not_existing_depending_value"]'));

                } else {

                    var depending_control_type = '';
                    var depending_data_type = '';
                    var depending_table_type = '';
                    var depending_table = '';

                    if (!utils.isUndefined($(element).parents('.modal-content').find('[name="integrity_depending_field"]').select2('val')) && $(element).parents('.modal-content').find('[name="integrity_depending_field"]').select2('val') !== '') {
                        depending_control_type = $(element).parents('.modal-content').find('[name="integrity_depending_field"]').select2('data')[0].controlType;
                        depending_data_type = $(element).parents('.modal-content').find('[name="integrity_depending_field"]').select2('data')[0].dataType;
                        depending_table_type = $(element).parents('.modal-content').find('[name="integrity_depending_field"]').select2('data')[0].tableType;
                        depending_table = $(element).parents('.modal-content').find('[name="integrity_depending_field"]').select2('data')[0].table;
                    }

                    var tableTypeName = '';
                    if (depending_table_type === 'master_table' || depending_table_type === 'master_facility_table') {
                        tableTypeName = 'master';
                    } else if (depending_table_type === 'course_table' || depending_table_type === 'course_facility_table') {
                        tableTypeName = 'course';
                    } else if (depending_table_type === 'period_table' || depending_table_type === 'period_facility_table') {
                        tableTypeName = 'period_' + depending_table;
                    }

                    setIntegrityFieldSelection('integrity_depending_field_value_from_date_field', 'date_fields_' + tableTypeName, 'tt-integrity-field validation-group-norm-date-from', $(element).parents('.modal-content').find('[name="integrity_depending_field"]').parents('form'));
                    setIntegrityFieldSelection('integrity_depending_field_value_till_date_field', 'date_fields_' + tableTypeName, 'tt-integrity-field validation-group-norm-date-till tt-disabled-integrity-select2', $(element).parents('.modal-content').find('[name="integrity_depending_field"]').parents('form'));

                    setIntegrityFieldSelection('integrity_depending_field_value_from_field', 'number_fields_' + tableTypeName, 'tt-integrity-field tt-integrity-deviation-value-field validation-depending-dependency-group-range-input-from', $(element).parents('.modal-content').find('[name="integrity_depending_field"]').parents('form'));
                    setIntegrityFieldSelection('integrity_depending_field_value_till_field', 'number_fields_' + tableTypeName, 'tt-integrity-field tt-integrity-deviation-value-field tt-disabled-integrity-select2 validation-depending-dependency-group-range-input-till', $(element).parents('.modal-content').find('[name="integrity_depending_field"]').parents('form'));

                    if (depending_control_type === 'input' || depending_control_type === 'input_with_additionalfield' || depending_control_type === 'textarea') {
                        if (depending_data_type === 'integer' || depending_data_type === 'decimal') {

                            $(element).parents('.modal-content').find('[name="integrity_depending_field_logical_from_field"]').val($("<textarea/>").html(aData[49]).text()).trigger('change.select2');

                            if (aData[49] !== '') {
                                $(element).parents('.modal-content').find('[name="integrity_depending_field_value_from"]').val(utils.numberToString(parseFloat(aData[50])));
                                utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_depending_field_value_from"]').parent(), aData[46], true);
                                if (aData[51] !== '0') {
                                    $(element).parents('.modal-content').find('[name="integrity_depending_field_value_from"]').val('');
                                    $(element).parents('.modal-content').find('[name="integrity_depending_field_value_from"]').prop('disabled', 'disabled');
                                    $(element).parents('.modal-content').find('[name="integrity_depending_field_value_from"]').parent().addClass('state-disabled');
                                    $(element).parents('.tt-field-input-numeric').find('[name="integrity_depending_field_value_from_dropdown_toggle"]').prop('disabled', 'disabled');
                                    $(element).parents('.modal-content').find('[name="integrity_depending_field_value_from_field"]').val(aData[51] + '|' + aData[52]).trigger('change.select2');
                                }
                            } else if (aData[56] !== '') {
                                utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_depending_field_value_from"]').parent(), aData[46], true);
                            }

                            if (aData[56] !== '') {
                                $(element).parents('.modal-content').find('[name="integrity_depending_field_value_till"]').val(utils.numberToString(parseFloat(aData[57])));
                                utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_depending_field_value_till"]').parent(), aData[46], true);
                                if (aData[58] !== '0') {
                                    $(element).parents('.modal-content').find('[name="integrity_depending_field_value_till"]').val('');
                                    $(element).parents('.modal-content').find('[name="integrity_depending_field_value_till"]').prop('disabled', 'disabled');
                                    $(element).parents('.modal-content').find('[name="integrity_depending_field_value_till"]').parent().addClass('state-disabled');
                                    $(element).parents('.tt-field-input-numeric').find('[name="integrity_depending_field_value_till_dropdown_toggle"]').prop('disabled', 'disabled');
                                    $(element).parents('.modal-content').find('[name="integrity_depending_field_value_till_field"]').val(aData[58] + '|' + aData[59]).trigger('change.select2');
                                }
                            } else if (aData[49] !== '') {
                                utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_depending_field_value_till"]').parent(), aData[46], true);
                            }

                            setIntegrityFieldsDependingOnLogicalOperator($(element).parents('.modal-content').find('[name="integrity_depending_field_logical_from_field"]'));
                            $(element).parents('.modal-content').find('[name="integrity_depending_field_logical_till_field"]').val($("<textarea/>").html(aData[56]).text()).trigger('change.select2');

                        }
                        else {

                            $(element).parents('.modal-content').find('[name="integrity_field_input"]').val(aData[63]);

                        }

                    } else if (depending_control_type === 'date_panel' || depending_control_type === 'date_range') {

                        $(element).parents('.modal-content').find('[name="integrity_depending_field_logical_from_date_field"]').val($("<textarea/>").html(aData[49]).text()).trigger('change.select2');
                        if (aData[51] !== '0') {
                            if (aData[53] === '+') {
                                $(element).parents('.modal-content').find('[name="integrity_depending_field_value_from_plus_minus"]')[0].checked = false;
                            } else {
                                $(element).parents('.modal-content').find('[name="integrity_depending_field_value_from_plus_minus"]')[0].checked = true;
                            }
                            $(element).parents('.modal-content').find('[name="integrity_depending_field_value_from_date_field"]').val(aData[51] + '|' + aData[52]).trigger('change.select2');
                            $(element).parents('.modal-content').find('[name="integrity_depending_field_value_from_date_range"]').val(aData[54]);
                            utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_depending_field_value_from_date_range"]').parent(), aData[55], true);

                        }

                        if (aData[58] !== '0') {
                            if (aData[60] === '+') {
                                $(element).parents('.modal-content').find('[name="integrity_depending_field_value_till_plus_minus"]')[0].checked = false;
                            } else {
                                $(element).parents('.modal-content').find('[name="integrity_depending_field_value_till_plus_minus"]')[0].checked = true;
                            }
                            $(element).parents('.modal-content').find('[name="integrity_depending_field_value_till_date_field"]').val(aData[58] + '|' + aData[59]).trigger('change.select2');
                            $(element).parents('.modal-content').find('[name="integrity_depending_field_value_till_date_range"]').val(aData[61]);
                            utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="integrity_depending_field_value_till_date_range"]').parent(), aData[62], true);

                        }

                        setIntegrityFieldsDependingOnLogicalOperator($(element).parents('.modal-content').find('[name="integrity_depending_field_logical_from_date_field"]'));
                        $(element).parents('.modal-content').find('[name="integrity_depending_field_logical_till_date_field"]').val($("<textarea/>").html(aData[56]).text()).trigger('change.select2');

                    } else {

                        $(element).parents('.modal-content').find('[name="integrity_depending_field_list"]').val(aData[63].split('$')).trigger('change.select2');

                    }

                }
            } else {

                $(element).parents('.modal-content').find('[name="integrity_depending_field_list"]').val(aData[63].split('$')).trigger('change.select2');
            }

        });
    }
}

function setIntegrityFieldsDependingOnLogicalOperator(element) {
    var selected_from_value = $(element).select2('val');

    // Auswahlliste mit Logik-Operatoren befüllen
    var data = [];

    if (selected_from_value === '') {
        data.push({ id: '>=', text: '>=' });
        data.push({ id: '>', text: '>' });
        data.push({ id: '<=', text: '<=' });
        data.push({ id: '<', text: '<' });
        data.push({ id: '=', text: '=' });
        data.push({ id: '!=', text: '!=' });
    } else if (selected_from_value === '>=' || selected_from_value === '>') {
        data.push({ id: '<=', text: '<=' });
        data.push({ id: '<', text: '<' });
    } else if (selected_from_value === '<=' || selected_from_value === '<') {
        data.push({ id: '>=', text: '>=' });
        data.push({ id: '>', text: '>' });
    }

    var select_class = $(element).data().logicClass;

    validator.reinitializeSelect2($('.' + select_class).parent(), 'tt-select2 select2-container ' + select_class + ' tt-disabled-integrity-select2', 'data-range="till"', data, false, true);

    if (selected_from_value === '=' || selected_from_value === '!=') {
        // Wertebereich (Input)
        if ($(element).parents('.tt-range-input').length) {
            $(element).parents('.tt-range-input').find('[name="integrity_logical_till_field"]').val(null).trigger('change.select2');
            $(element).parents('.tt-range-input').find('[name="integrity_value_till"]').val('');
            $(element).parents('.tt-range-input').find('[name="integrity_value_till_field"]').val(null).trigger('change.select2');
            $(element).parents('.tt-range-input').find('[name="integrity_value_till_field_unit_1"]').val(null).trigger('change.select2');
            $(element).parents('.tt-range-input').find('[name="integrity_value_till_field_unit_2"]').val(null).trigger('change.select2');

            $(element).parents('.tt-range-input').find('[name="integrity_logical_till_field"]').prop('disabled', 'disabled');
            $(element).parents('.tt-range-input').find('[name="integrity_value_till"]').prop('disabled', 'disabled');
            $(element).parents('.tt-range-input').find('[name="integrity_value_till"]').parent().addClass('state-disabled');
            $(element).parents('.tt-range-input').find('[name="integrity_value_till_dropdown_toggle"]').prop('disabled', 'disabled');
            $(element).parents('.tt-range-input').find('[name="integrity_value_till_field"]').prop('disabled', 'disabled');
            $(element).parents('.tt-range-input').find('[name="integrity_value_till_field_unit_1"]').prop('disabled', 'disabled');
            $(element).parents('.tt-range-input').find('[name="integrity_value_till_field_unit_2"]').prop('disabled', 'disabled');
            $(element).parents('.tt-range-date').find('[name="integrity_value_till_plus_minus"]').prop('disabled', 'disabled');
        }

        // Wertebereich (Datum)
        if ($(element).parents('.tt-range-date').length) {
            $(element).parents('.tt-range-date').find('[name="integrity_logical_till_date_field"]').val(null).trigger('change.select2');
            $(element).parents('.tt-range-date').find('[name="integrity_value_till_date_field"]').val(null).trigger('change.select2');
            $(element).parents('.tt-range-date').find('[name="integrity_value_till_date_range"]').val('');
            $(element).parents('.tt-range-date').find('[name="integrity_value_till_plus_minus"]')[0].checked = false;
            utils.setValueForInputWithDropDownField($(element).parents('.tt-range-date').find('[name="integrity_value_till_date_range"]').parent(), 'years', true);

            $(element).parents('.tt-range-date').find('[name="integrity_logical_till_date_field"]').prop('disabled', 'disabled');
            $(element).parents('.tt-range-date').find('[name="integrity_value_till_date_field"]').prop('disabled', 'disabled');
            $(element).parents('.tt-range-date').find('[name="integrity_value_till_date_range"]').parent().addClass('state-disabled');
            $(element).parents('.tt-range-date').find('[name="integrity_value_till_date_dropdown_toggle"]').prop('disabled', 'disabled');
            $(element).parents('.tt-range-date').find('[name="integrity_value_till_date_range"]').prop('disabled', 'disabled');
            $(element).parents('.tt-range-date').find('[name="integrity_value_till_plus_minus"]').prop('disabled', 'disabled');
        }

        // Abhängigkeit - Feld (Input)
        if ($(element).parents('.tt-field-input-numeric').length) {
            $(element).parents('.tt-field-input-numeric').find('[name="integrity_field_logical_till_field"]').val(null).trigger('change.select2');
            $(element).parents('.tt-field-input-numeric').find('[name="integrity_field_value_till"]').val('');
            $(element).parents('.tt-field-input-numeric').find('[name="integrity_field_value_till_field"]').val(null).trigger('change.select2');

            $(element).parents('.tt-field-input-numeric').find('[name="integrity_field_logical_till_field"]').prop('disabled', 'disabled');
            $(element).parents('.tt-field-input-numeric').find('[name="integrity_field_value_till"]').prop('disabled', 'disabled');
            $(element).parents('.tt-field-input-numeric').find('[name="integrity_field_value_till"]').parent().addClass('state-disabled');
            $(element).parents('.tt-field-input-numeric').find('[name="integrity_field_value_till_dropdown_toggle"]').prop('disabled', 'disabled');
            $(element).parents('.tt-field-input-numeric').find('[name="integrity_field_value_till_field"]').prop('disabled', 'disabled');
            $(element).parents('.tt-field-input-numeric').find('[name="integrity_field_value_till_plus_minus"]').prop('disabled', 'disabled');
        }

        // Abhängigkeit - Feld (Datum)
        if ($(element).parents('.tt-field-date').length) {
            $(element).parents('.tt-field-date').find('[name="integrity_field_logical_till_date_field"]').val(null).trigger('change.select2');
            $(element).parents('.tt-field-date').find('[name="integrity_field_value_till_date_field"]').val(null).trigger('change.select2');
            $(element).parents('.tt-field-date').find('[name="integrity_field_value_till_date_range"]').val('');
            $(element).parents('.tt-field-date').find('[name="integrity_field_value_till_plus_minus"]')[0].checked = false;
            utils.setValueForInputWithDropDownField($(element).parents('.tt-field-date').find('[name="integrity_field_value_till_date_range"]').parent(), 'years', true);

            $(element).parents('.tt-field-date').find('[name="integrity_field_logical_till_date_field"]').prop('disabled', 'disabled');
            $(element).parents('.tt-field-date').find('[name="integrity_field_value_till_date_field"]').prop('disabled', 'disabled');
            $(element).parents('.tt-field-date').find('[name="integrity_field_value_till_date_range"]').parent().addClass('state-disabled');
            $(element).parents('.tt-field-date').find('[name="integrity_field_value_till_date_dropdown_toggle"]').prop('disabled', 'disabled');
            $(element).parents('.tt-field-date').find('[name="integrity_field_value_till_date_range"]').prop('disabled', 'disabled');
            $(element).parents('.tt-field-date').find('[name="integrity_field_value_till_plus_minus"]').prop('disabled', 'disabled');
        }

        // Abhängigkeit - abhängiges Feld (Input)
        if ($(element).parents('.tt-depending-field-input-numeric').length) {
            $(element).parents('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_logical_till_field"]').val(null).trigger('change.select2');
            $(element).parents('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_value_till"]').val('');
            $(element).parents('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_value_till_field"]').val(null).trigger('change.select2');

            $(element).parents('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_logical_till_field"]').prop('disabled', 'disabled');
            $(element).parents('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_value_till"]').prop('disabled', 'disabled');
            $(element).parents('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_value_till"]').parent().addClass('state-disabled');
            $(element).parents('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_value_till_dropdown_toggle"]').prop('disabled', 'disabled');
            $(element).parents('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_value_till_field"]').prop('disabled', 'disabled');
            $(element).parents('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_value_till_plus_minus"]').prop('disabled', 'disabled');
        }

        // Abhängigkeit - abhängiges Feld (Datum)
        if ($(element).parents('.tt-depending-field-date').length) {
            $(element).parents('.tt-depending-field-date').find('[name="integrity_depending_field_logical_till_date_field"]').val(null).trigger('change.select2');
            $(element).parents('.tt-depending-field-date').find('[name="integrity_depending_field_value_till_date_field"]').val(null).trigger('change.select2');
            $(element).parents('.tt-depending-field-date').find('[name="integrity_depending_field_value_till_date_range"]').val('');
            $(element).parents('.tt-depending-field-date').find('[name="integrity_depending_field_value_till_plus_minus"]')[0].checked = false;
            utils.setValueForInputWithDropDownField($(element).parents('.tt-depending-field-date').find('[name="integrity_depending_field_value_till_date_range"]').parent(), 'years', true);

            $(element).parents('.tt-depending-field-date').find('[name="integrity_depending_field_logical_till_date_field"]').prop('disabled', 'disabled');
            $(element).parents('.tt-depending-field-date').find('[name="integrity_depending_field_value_till_date_field"]').prop('disabled', 'disabled');
            $(element).parents('.tt-depending-field-date').find('[name="integrity_depending_field_value_till_date_range"]').parent().addClass('state-disabled');
            $(element).parents('.tt-depending-field-date').find('[name="integrity_depending_field_value_till_date_dropdown_toggle"]').prop('disabled', 'disabled');
            $(element).parents('.tt-depending-field-date').find('[name="integrity_depending_field_value_till_date_range"]').prop('disabled', 'disabled');
            $(element).parents('.tt-depending-field-date').find('[name="integrity_depending_field_value_till_plus_minus"]').prop('disabled', 'disabled');
        }
    } else {
        // Wertebereich (Input)
        if ($(element).parents('.tt-range-input').length) {
            $(element).parents('.tt-range-input').find('[name="integrity_logical_till_field"]').prop('disabled', '');
            $(element).parents('.tt-range-input').find('[name="integrity_value_till"]').prop('disabled', '');
            $(element).parents('.tt-range-input').find('[name="integrity_value_till"]').parent().removeClass('state-disabled');
            $(element).parents('.tt-range-input').find('[name="integrity_value_till_dropdown_toggle"]').prop('disabled', '');
            $(element).parents('.tt-range-input').find('[name="integrity_value_till_field"]').prop('disabled', '');
            $(element).parents('.tt-range-input').find('[name="integrity_value_till_field_unit_1"]').prop('disabled', '');
            $(element).parents('.tt-range-input').find('[name="integrity_value_till_field_unit_2"]').prop('disabled', '');

            setIntegrityValueTill($(element).parents('.tt-range-input').find('[name="integrity_value_till_field"]'), '.tt-range-input');
        }

        // Wertebereich (Datum)
        if ($(element).parents('.tt-range-date').length) {
            $(element).parents('.tt-range-date').find('[name="integrity_logical_till_date_field"]').prop('disabled', '');
            $(element).parents('.tt-range-date').find('[name="integrity_value_till_date_field"]').prop('disabled', '');
            $(element).parents('.tt-range-date').find('[name="integrity_value_till_date_range"]').parent().removeClass('state-disabled');
            $(element).parents('.tt-range-date').find('[name="integrity_value_till_date_dropdown_toggle"]').prop('disabled', '');
            $(element).parents('.tt-range-date').find('[name="integrity_value_till_date_range"]').prop('disabled', '');
            $(element).parents('.tt-range-date').find('[name="integrity_value_till_plus_minus"]').prop('disabled', '');
        }

        // Abhängigkeit - Feld (Input)
        if ($(element).parents('.tt-field-input-numeric').length) {
            $(element).parents('.tt-field-input-numeric').find('[name="integrity_field_logical_till_field"]').prop('disabled', '');
            $(element).parents('.tt-field-input-numeric').find('[name="integrity_field_value_till"]').prop('disabled', '');
            $(element).parents('.tt-field-input-numeric').find('[name="integrity_field_value_till"]').parent().removeClass('state-disabled');
            $(element).parents('.tt-field-input-numeric').find('[name="integrity_field_value_till_dropdown_toggle"]').prop('disabled', '');
            $(element).parents('.tt-field-input-numeric').find('[name="integrity_field_value_till_field"]').prop('disabled', '');

            setIntegrityValueTill($(element).parents('.tt-field-input-numeric').find('[name="integrity_field_value_till_field"]'), '.tt-field-input-numeric');
        }

        // Abhängigkeit - Feld (Datum)
        if ($(element).parents('.tt-field-date').length) {
            $(element).parents('.tt-field-date').find('[name="integrity_field_logical_till_date_field"]').prop('disabled', '');
            $(element).parents('.tt-field-date').find('[name="integrity_field_value_till_date_field"]').prop('disabled', '');
            $(element).parents('.tt-field-date').find('[name="integrity_field_value_till_date_range"]').parent().removeClass('state-disabled');
            $(element).parents('.tt-field-date').find('[name="integrity_field_value_till_date_dropdown_toggle"]').prop('disabled', '');
            $(element).parents('.tt-field-date').find('[name="integrity_field_value_till_date_range"]').prop('disabled', '');
            $(element).parents('.tt-field-date').find('[name="integrity_field_value_till_plus_minus"]').prop('disabled', '');
        }

        // Abhängigkeit - abhängiges Feld (Input)
        if ($(element).parents('.tt-depending-field-input-numeric').length) {
            $(element).parents('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_logical_till_field"]').prop('disabled', '');
            $(element).parents('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_value_till"]').prop('disabled', '');
            $(element).parents('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_value_till"]').parent().removeClass('state-disabled');
            $(element).parents('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_value_till_dropdown_toggle"]').prop('disabled', '');
            $(element).parents('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_value_till_field"]').prop('disabled', '');

            setIntegrityValueTill($(element).parents('.tt-depending-field-input-numeric').find('[name="integrity_depending_field_value_till_field"]'), '.tt-depending-field-input-numeric');
        }

        // Abhängigkeit - abhängiges Feld (Datum)
        if ($(element).parents('.tt-depending-field-date').length) {
            $(element).parents('.tt-depending-field-date').find('[name="integrity_depending_field_logical_till_date_field"]').prop('disabled', '');
            $(element).parents('.tt-depending-field-date').find('[name="integrity_depending_field_value_till_date_field"]').prop('disabled', '');
            $(element).parents('.tt-depending-field-date').find('[name="integrity_depending_field_value_till_date_range"]').parent().removeClass('state-disabled');
            $(element).parents('.tt-depending-field-date').find('[name="integrity_depending_field_value_till_date_dropdown_toggle"]').prop('disabled', '');
            $(element).parents('.tt-depending-field-date').find('[name="integrity_depending_field_value_till_date_range"]').prop('disabled', '');
            $(element).parents('.tt-depending-field-date').find('[name="integrity_depending_field_value_till_plus_minus"]').prop('disabled', '');
        }
    }
}

function setIntegrityValueTill(element, parent) {
    var range = $(element).attr('data-range');

    if ($(element).val() === '') {
        $(element).parents(parent).find('.tt-integrity-deviation-value[data-range="' + range + '"]').prop('disabled', '');
        $(element).parents(parent).find('.tt-integrity-deviation-value[data-range="' + range + '"]').parent().removeClass('state-disabled');
        $(element).parents(parent).find('.dropdown-toggle[data-range="' + range + '"]').prop('disabled', '');
    } else {
        $(element).parents(parent).find('.tt-integrity-deviation-value[data-range="' + range + '"]').prop('disabled', 'disabled');
        $(element).parents(parent).find('.tt-integrity-deviation-value[data-range="' + range + '"]').parent().addClass('state-disabled');
        $(element).parents(parent).find('.dropdown-toggle[data-range="' + range + '"]').prop('disabled', 'disabled');
        $(element).parents(parent).find('.tt-integrity-deviation-value[data-range="' + range + '"]').val('');
    }
}

function setIntegrityDependencyFieldsOfValue(element) {
    // Felder inaktiv setzen
    $(element).parents('form').find('.tt-field-values').find('.dropdown-toggle').prop('disabled', 'disabled');
    $(element).parents('form').find('.tt-field-values').find('input:not([type="checkbox"])').prop('disabled', 'disabled');
    $(element).parents('form').find('.tt-field-values').find('input:not([type="checkbox"])').parent().addClass('state-disabled');
    $(element).parents('form').find('.tt-field-values').find('.tt-select2').prop('disabled', 'disabled');
    $(element).parents('form').find('.tt-field-values').find('[type="checkbox"]:not([name="integrity_not_existing_value"],[name="integrity_existing_value"])').prop('disabled', 'disabled');

    if (!$(element)[0].checked) {
        // Felder wieder aktiv setzen
        $(element).parents('form').find('.tt-field-values').find('.dropdown-toggle:not([name="integrity_field_value_till_dropdown_toggle"],[name="integrity_field_value_till_date_dropdown_toggle"])').prop('disabled', '');
        $(element).parents('form').find('.tt-field-values').find('input:not([type="radio"],[type="checkbox"],[name="integrity_field_value_till"],[name="integrity_field_value_till_date_range"],.tt-disabled-integrity-select2)').prop('disabled', '');
        $(element).parents('form').find('.tt-field-values').find('input:not([type="radio"],[type="checkbox"],[name="integrity_field_value_till"],[name="integrity_field_value_till_date_range"],.tt-disabled-integrity-select2)').parent().removeClass('state-disabled');
        $(element).parents('form').find('.tt-field-values').find('.tt-select2:not(.tt-disabled-integrity-select2)').prop('disabled', '');
        $(element).parents('form').find('.tt-field-values').find('[type="checkbox"]:not([name="integrity_not_existing_value"],[name="integrity_existing_value"],[name="integrity_field_value_till_plus_minus"])').prop('disabled', '');
        $(element).parents('form').find('.tt-field-values').find('[type="radio"]').prop('disabled', false);
    }
}

function setIntegrityDependencyFieldsOfDepValue(element) {
    // Felder inaktiv setzen
    $(element).parents('form').find('.tt-depending-field-values').find('.dropdown-toggle').prop('disabled', 'disabled');
    $(element).parents('form').find('.tt-depending-field-values').find('input:not([type="checkbox"],[name="integrity_depending_field_value_till"])').prop('disabled', 'disabled');
    $(element).parents('form').find('.tt-depending-field-values').find('input:not([type="checkbox"])').parent().addClass('state-disabled');
    $(element).parents('form').find('.tt-depending-field-values').find('.tt-select2').prop('disabled', 'disabled');
    $(element).parents('form').find('.tt-depending-field-values').find('[type="checkbox"]:not([name="integrity_existing_depending_value"],[name="integrity_not_existing_depending_value"])').prop('disabled', 'disabled');
    $(element).parents('form').find('.tt-depending-field-values').find('[type="radio"]').prop('disabled', true);
    $(element).parents('form').find('.tt-depending-field-values').find('[name="integrity_dependency_frequency"]').prop('disabled', false);
    $(element).parents('form').find('.tt-depending-field-values').find('[name="integrity_dependency_frequency"]').parent().removeClass('state-disabled');
    $(element).parents('form').find('.tt-depending-field-values').find('[name="integrity_dependency_optional"]').prop('disabled', false);
    $(element).parents('form').find('.tt-depending-field-values').find('[name="integrity_dependency_optional"]').parent().removeClass('state-disabled');

    if (!$(element)[0].checked) {
        // Felder wieder aktiv setzen
        $(element).parents('form').find('.tt-depending-field-values').find('.dropdown-toggle:not([name="integrity_depending_field_value_till_dropdown_toggle"],[name="integrity_depending_field_value_till_date_dropdown_toggle"])').prop('disabled', '');
        $(element).parents('form').find('.tt-depending-field-values').find('input:not([type="radio"],[type="checkbox"],[name="integrity_depending_field_value_till"],[name="integrity_depending_field_value_till_date_range"],.tt-disabled-integrity-select2)').prop('disabled', '');
        $(element).parents('form').find('.tt-depending-field-values').find('input:not([type="radio"],[type="checkbox"],[name="integrity_depending_field_value_till"],[name="integrity_depending_field_value_till_date_range"],.tt-disabled-integrity-select2)').parent().removeClass('state-disabled');
        $(element).parents('form').find('.tt-depending-field-values').find('.tt-select2:not(.tt-disabled-integrity-select2)').prop('disabled', '');
        $(element).parents('form').find('.tt-depending-field-values').find('[type="checkbox"]:not([name="integrity_existing_depending_value"],[name="integrity_not_existing_depending_value"],[name="integrity_depending_field_value_till_plus_minus"])').prop('disabled', '');
    }
}

function showIntegrityDependencySpecificFieldsOfDepValue(element) {

    return $.Deferred(function (defer) {
        $(element).parents('form').find('.tt-depending-field-date').addClass('hide');
        $(element).parents('form').find('.tt-depending-field-list').addClass('hide');
        $(element).parents('form').find('.tt-depending-field-input').addClass('hide');
        $(element).parents('form').find('.tt-depending-field-input-numeric').addClass('hide');

        var control_type = '';
        var data_type = '';
        var completeness_type = $(element).parents('form').find('[name="integrity_dependency_frequency"]:checked').val();

        if (!utils.isUndefined($(element).select2('val')) && $(element).select2('val') !== '') {
            control_type = $(element).select2('data')[0].controlType;
            data_type = $(element).select2('data')[0].dataType;
        }

        if (!utils.isUndefined(control_type) && control_type !== '' && !utils.isUndefined(completeness_type) && completeness_type !== '') {
            if (completeness_type == 'no') {

                $(element).parents('form').find('.tt-existing-dep-value').removeClass('hide');
                $(element).parents('form').find('.tt-not-existing-dep-value').removeClass('hide');
                $(element).parents('form').find('.tt-or-dep-value').removeClass('hide');

                if (control_type === 'input' || control_type === 'input_with_additionalfield' || control_type === 'textarea') {
                    if (data_type === 'integer' || data_type === 'decimal') {
                        $(element).parents('form').find('.tt-depending-field-input-numeric').removeClass('hide');

                        // Auswahlliste für Einheit befüllen
                        $('.depending-input-with-dropdown-unit').find('ul.dropdown-menu').empty();
                        $('.depending-input-with-dropdown-unit').find('.input-with-dropdown').find('i').remove();

                        var splitted_value = $(element).select2('val').split('|');

                        if (splitted_value.length === 2) {

                            ajax.ajaxCallDeferred('admin/dataview/labunits/id/' + splitted_value[0] + '/name/' + splitted_value[1], 'GET', data, false).done(function(data) {

                                if (ajax.ajaxSucceeded(data)) {
                                    var default_unit = '';
                                    if (!utils.isUndefined(data) && data !== '') {
                                        $('.depending-input-with-dropdown-unit').find('input').parent().parent().addClass('display-flex');
                                        $('.depending-input-with-dropdown-unit').find('input').parent().addClass('input-with-dropdown');
                                        $('.depending-input-with-dropdown-unit').find('.tt-input-dropdown').removeClass('hide');

                                        var lab_units_input = data.split('|');
                                        jQuery.each(lab_units_input, function (i, val) {

                                            var active = '';
                                            var lab_unit = val.split('#');

                                            if (lab_unit[1] === 'true') {
                                                active = ' class="active"';
                                                default_unit = lab_unit[2];
                                                $('.depending-input-with-dropdown-unit').find('.input-with-dropdown').append('<i class="icon-append icon-append-unit">' + default_unit + '</i>');
                                            }

                                            var item =
                                                '<li' + active + '>' +
                                                '<a class="tt-select-value tt-select-integrity-unit-value" data-format-value="' + lab_unit[2] + '" href="#">' + lab_unit[2] + '</a>' +
                                                '</li>';
                                            $('.depending-input-with-dropdown-unit').find('ul.dropdown-menu').append(item);
                                        });
                                    } else {
                                        $('.depending-input-with-dropdown-unit').find('input').parent().parent().removeClass('display-flex');
                                        $('.depending-input-with-dropdown-unit').find('input').parent().removeClass('input-with-dropdown');
                                        $('.depending-input-with-dropdown-unit').find('.tt-input-dropdown').addClass('hide');
                                    }
                                    $(element).parents('form').validate().settings.rules = validator.getRules($(element).parents('form'));
                                    defer.resolve();
                                } else {
                                    defer.reject();
                                }
                            });

                        } else {

                            $('.depending-input-with-dropdown-unit').find('input').parent().parent().removeClass('display-flex');
                            $('.depending-input-with-dropdown-unit').find('input').parent().removeClass('input-with-dropdown');
                            $('.depending-input-with-dropdown-unit').find('.tt-input-dropdown').addClass('hide');
                            $(element).parents('form').validate().settings.rules = validator.getRules($(element).parents('form'));
                            defer.resolve();
                        }
                    } else {
                        $(element).parents('form').find('.tt-depending-field-input').removeClass('hide');
                        $(element).parents('form').validate().settings.rules = validator.getRules($(element).parents('form'));
                        defer.resolve();
                    }
                } else if (control_type === 'date_panel' || control_type === 'date_range') {
                    $(element).parents('form').find('.tt-depending-field-date').removeClass('hide');
                    $(element).parents('form').validate().settings.rules = validator.getRules($(element).parents('form'));
                    defer.resolve();
                } else {
                    $(element).parents('form').find('.tt-depending-field-list').removeClass('hide');

                    // Auswahlliste mit Ausprägungen befüllen
                    var input = $(element).select2('data')[0].controlValues;
                    var data = [];
                    if (!utils.isUndefined(input) && input !== '') {

                        var control_types = input.split('|');

                        jQuery.each(control_types, function (i, val) {

                            var control_type_values = val.split('#');

                            if (control_type_values.length === 2) {
                                data.push({id: control_type_values[0], text: control_type_values[1]});
                            }
                        });

                        // Ausprägungen
                        validator.reinitializeSelect2($('.integrity-depending-field-list'), 'tt-select2 validation-group-dependency-depending-field select2-container', '', data, true);
                    }
                    $(element).parents('form').validate().settings.rules = validator.getRules($(element).parents('form'));
                    defer.resolve();
                }
            } else {
                $(element).parents('form').find('.tt-depending-field-list').removeClass('hide');

                $(element).parents('form').find('.tt-existing-dep-value').addClass('hide');
                $(element).parents('form').find('.tt-not-existing-dep-value').addClass('hide');
                $(element).parents('form').find('.tt-or-dep-value').addClass('hide');

                // Auswahlliste mit Ausprägungen befüllen
                var data = [];
                var controlTypeValues = $(element).select2('data')[0].controlValues;
                var format_fields = $(element).select2('data')[0].formatFields.split('|');
                if ((!utils.isUndefined(controlTypeValues) && controlTypeValues !== '') || control_type === 'input' || control_type === 'input_with_additionalfield' || control_type === 'textarea' || control_type === 'date_panel' || control_type === 'date_range') {
                    if (!utils.isUndefined(controlTypeValues) && controlTypeValues !== '') {
                        var control_types = controlTypeValues.split('|');

                        jQuery.each(control_types, function (i, val) {

                            var control_type_values = val.split('#');

                            if (control_type_values.length === 2) {
                                data.push({id: control_type_values[0], text: control_type_values[1]});
                            }
                        });
                    } else if (control_type === 'input' || control_type === 'input_with_additionalfield' || control_type === 'textarea') {
                        data.push({id: 0, text: Lang.get('tripletrax.value')});

                        if (jQuery.inArray('unknown', format_fields) >= 0) {
                            data.push({id: 1, text: Lang.get('tripletrax.unknown_value')});
                        }
                        if (jQuery.inArray('not_collected', format_fields) >= 0) {
                            data.push({id: 2, text: Lang.get('tripletrax.not_collected_value')});
                        }
                        if (jQuery.inArray('not_measurable', format_fields) >= 0) {
                            data.push({id: 3, text: Lang.get('tripletrax.not_measurable_value')});
                        }
                    } else if (control_type === 'date_panel' || control_type === 'date_range') {
                        data.push({id: 0, text: Lang.get('tripletrax.date')});

                        if (jQuery.inArray('unknown', format_fields) >= 0) {
                            data.push({id: 1, text: Lang.get('tripletrax.unknown_value')});
                        }
                        if (jQuery.inArray('not_collected', format_fields) >= 0) {
                            data.push({id: 2, text: Lang.get('tripletrax.not_collected_value')});
                        }
                        if (jQuery.inArray('continuing', format_fields) >= 0) {
                            data.push({id: 4, text: Lang.get('tripletrax.continuing_value')});
                        }
                    }

                    // Ausprägungen
                    validator.reinitializeSelect2($('.integrity-depending-field-list'), 'tt-select2 validation-group-dependency-depending-field select2-container', '', data, true);
                }
                $(element).parents('form').validate().settings.rules = validator.getRules($(element).parents('form'));
                defer.resolve();
            }
        } else {
            $(element).parents('form').validate().settings.rules = validator.getRules($(element).parents('form'));
            defer.resolve();
        }

    }).promise();
}

function showIntegritySpecificFieldsOfValue(element) {
    $(element).parents('form').find('.tt-integrity-separator').addClass('hide');
    $(element).parents('form').find('.tt-integrity-type').addClass('hide');
    $(element).parents('form').find('.tt-integrity-gender').addClass('hide');
    $(element).parents('form').find('.tt-integrity-date-range').addClass('hide');
    $(element).parents('form').find('.tt-completeness').addClass('hide');
    $(element).parents('form').find('.tt-range-input').addClass('hide');
    $(element).parents('form').find('.tt-range-list').addClass('hide');
    $(element).parents('form').find('.tt-range-date').addClass('hide');
    $(element).parents('form').find('.tt-deviation').addClass('hide');
    $(element).parents('form').find('.tt-deviation-input').addClass('hide');
    $(element).parents('form').find('.tt-dependency').addClass('hide');

    $(element).parents('form').find('[name="integrity_integritytype"]').prop('disabled', false);

    var control_type = $(element).parents('.tt-content-dialog').find('[name="control_type"]').val();
    var data_type = $(element).parents('.tt-content-dialog').find('[name="data_type"]').val();

    if ($(element).val() === 'completeness') {
        $(element).parents('form').find('.tt-integrity-separator').removeClass('hide');
        $(element).parents('form').find('.tt-integrity-gender').removeClass('hide');
        $(element).parents('form').find('.tt-integrity-date-range').removeClass('hide');
        $(element).parents('form').find('.tt-completeness').removeClass('hide');
        if (control_type === 'checkbox' || control_type === 'checkbox_with_additionalfield' || control_type === 'checkbox_with_two_additionalfields') {
            $(element).parents('form').find('.tt-row-range-of-values').addClass('hide');
        } else {
            $(element).parents('form').find('.tt-row-range-of-values').removeClass('hide');
        }
        $(element).parents('form').find('[name="integrity_integritytype"]').prop('disabled', true);
        $(element).parents('form').find('[name="integrity_integritytype"][value="strict"]')[0].checked = true;
    } else if ($(element).val() === 'range') {
        $(element).parents('form').find('.tt-integrity-separator').removeClass('hide');
        $(element).parents('form').find('.tt-integrity-type').removeClass('hide');
        $(element).parents('form').find('.tt-integrity-gender').removeClass('hide');
        $(element).parents('form').find('.tt-integrity-date-range').removeClass('hide');
        if (control_type === 'input' || control_type === 'input_with_additionalfield' || control_type === 'textarea') {
            $(element).parents('form').find('.tt-range-input').removeClass('hide');
        } else if (control_type === 'date_panel' || control_type === 'date_range') {
            $(element).parents('form').find('.tt-range-date').removeClass('hide');
        } else {
            $(element).parents('form').find('.tt-range-list').removeClass('hide');
        }
    } else if ($(element).val() === 'deviation') {
        $(element).parents('form').find('.tt-integrity-separator').removeClass('hide');
        $(element).parents('form').find('.tt-integrity-type').removeClass('hide');
        $(element).parents('form').find('.tt-integrity-gender').removeClass('hide');
        $(element).parents('form').find('.tt-integrity-date-range').removeClass('hide');
        if (data_type === 'integer' || data_type === 'decimal') {
            $(element).parents('form').find('.tt-deviation-input').removeClass('hide');
        } else {
            $(element).parents('form').find('.tt-deviation').removeClass('hide');
        }
    } else if ($(element).val() === 'dependency') {
        $(element).parents('form').find('.tt-integrity-separator').removeClass('hide');
        $(element).parents('form').find('.tt-integrity-type').removeClass('hide');
        $(element).parents('form').find('.tt-integrity-gender').removeClass('hide');
        $(element).parents('form').find('.tt-integrity-date-range').removeClass('hide');
        $(element).parents('form').find('.tt-dependency').removeClass('hide');

        $(element).parents('form').find('.tt-field-date').addClass('hide');
        $(element).parents('form').find('.tt-field-list').addClass('hide');
        $(element).parents('form').find('.tt-field-input').addClass('hide');
        $(element).parents('form').find('.tt-field-input-numeric').addClass('hide');

        //$(element).parents('form').find('[name="integrity_integritytype"]').prop('disabled', true);
        //$(element).parents('form').find('[name="integrity_integritytype"][value="strict"]')[0].checked = true;

        if (control_type === 'input' || control_type === 'input_with_additionalfield' || control_type === 'textarea') {
            if (data_type === 'integer' || data_type === 'decimal') {
                $(element).parents('form').find('.tt-field-input-numeric').removeClass('hide');
            } else {
                $(element).parents('form').find('.tt-field-input').removeClass('hide');
            }
        } else if (control_type === 'date_panel' || control_type === 'date_range') {
            $(element).parents('form').find('.tt-field-date').removeClass('hide');
        } else {
            $(element).parents('form').find('.tt-field-list').removeClass('hide');
        }
    } else if ($(element).val() === 'restriction') {
        $(element).parents('form').find('.tt-integrity-separator').removeClass('hide');
        $(element).parents('form').find('.tt-integrity-gender').removeClass('hide');
        $(element).parents('form').find('.tt-integrity-date-range').removeClass('hide');
    }

    $(element).parents('form').validate().settings.rules = validator.getRules($(element).parents('form'));
}

function loadIntegrityComboboxValues(controlType, dataType, tableType, controlTypeValues, units, isAdditionalField, formatFields, matchField, isRestriction) {

    // Auswahlliste mit Ausprägungen befüllen (nur bei Radiobuttons und Comboboxen)
    var data = [];

    if ((!utils.isUndefined(controlTypeValues) && controlTypeValues !== '') || controlType === 'input' || controlType === 'input_with_additionalfield' || controlType === 'textarea' || controlType === 'date_panel' || controlType === 'date_range') {
        if (!utils.isUndefined(controlTypeValues) && controlTypeValues !== '') {
            var control_types = controlTypeValues.split('|');

            jQuery.each(control_types, function (i, val) {

                var control_type_values = val.split('#');

                if (control_type_values.length === 2) {
                    data.push({ id: control_type_values[0], text: control_type_values[1] });
                }
            });
        } else if (controlType === 'input' || controlType === 'input_with_additionalfield' || controlType === 'textarea') {
            data.push({ id: 0, text: Lang.get('tripletrax.value') });

            if (jQuery.inArray('unknown', formatFields) >= 0) {
                data.push({ id: 1, text: Lang.get('tripletrax.unknown_value') });
            }
            if (jQuery.inArray('not_collected', formatFields) >= 0) {
                data.push({ id: 2, text: Lang.get('tripletrax.not_collected_value') });
            }
            if (jQuery.inArray('not_measurable', formatFields) >= 0) {
                data.push({ id: 3, text: Lang.get('tripletrax.not_measurable_value') });
            }
        } else if (controlType === 'date_panel' || controlType === 'date_range') {
            data.push({ id: 0, text: Lang.get('tripletrax.date') });

            if (jQuery.inArray('unknown', formatFields) >= 0) {
                data.push({ id: 1, text: Lang.get('tripletrax.unknown_value') });
            }
            if (jQuery.inArray('not_collected', formatFields) >= 0) {
                data.push({ id: 2, text: Lang.get('tripletrax.not_collected_value') });
            }
            if (jQuery.inArray('continuing', formatFields) >= 0) {
                data.push({ id: 4, text: Lang.get('tripletrax.continuing_value') });
            }
        }

        // Vollständigkeit
        validator.reinitializeSelect2($('.completeness-range-of-values'), 'tt-select2 select2-container', '', data, true);

        // Datenbereich
        validator.reinitializeSelect2($('.integrity-control-type'), 'tt-select2 select2-container', '', data, true);

        // Abhängigkeit
        validator.reinitializeSelect2($('.integrity-field-list'), 'tt-select2 validation-group-dependency-field select2-container', '', data, true);
    }

    // Auswahlliste für Typ der Integritätsregel je nach eigenem Datentyp befüllen
    data = [];

    if (isRestriction) {
        data.push({id: 'restriction', text: Lang.get('tripletrax.restriction')});
    } else {
        if (!isAdditionalField || controlType === 'date_range') {
            data.push({id: 'completeness', text: Lang.get('tripletrax.completeness')});
        }
        if (!utils.isIDATFieldInDatabase(matchField)) {
            // Felder, welche nur in IDAT gespeichert sind, haben lediglich Vollständigkeiten als Integritätsregeln
            if (controlType === 'input' || controlType === 'input_with_additionalfield' || controlType === 'textarea') {
                if (dataType === 'integer' || dataType === 'decimal') {
                    // Nur bei Input-Felder, welche den Datentyp Integer oder Dezimal haben
                    data.push({id: 'range', text: Lang.get('tripletrax.range')});
                }
                if (tableType !== 'period_table' && tableType !== 'period_facility_table') {
                    data.push({id: 'deviation', text: Lang.get('tripletrax.deviation')});
                }
                data.push({id: 'dependency', text: Lang.get('tripletrax.dependency')});
            } else if (controlType === 'checkbox' || controlType === 'checkbox_with_additionalfield' || controlType === 'checkbox_with_two_additionalfields') {
                if (tableType !== 'period_table' && tableType !== 'period_facility_table') {
                    data.push({id: 'deviation', text: Lang.get('tripletrax.deviation')});
                }
                data.push({id: 'dependency', text: Lang.get('tripletrax.dependency')});
            } else {
                data.push({id: 'range', text: Lang.get('tripletrax.range')});
                if (tableType !== 'period_table' && tableType !== 'period_facility_table') {
                    data.push({id: 'deviation', text: Lang.get('tripletrax.deviation')});
                }
                data.push({id: 'dependency', text: Lang.get('tripletrax.dependency')});
            }
        }
    }

    validator.reinitializeSelect2($('.integrity-type'), 'input-sm tt-select2 tt-select-integrity-type tt-completeness-rule-group select2-container', '', data, false);

    // Auswahlliste für Einheit befüllen (nur bei Input-Feldern)
    if (controlType === 'input' || controlType === 'input_with_additionalfield' || controlType === 'textarea') {
        $('.input-with-dropdown-unit').find('ul.dropdown-menu').empty();
        $('.input-with-dropdown-unit').find('.input-with-dropdown').find('i').remove();

        var default_unit = '';
        if (!utils.isUndefined(units) && units !== '') {
            $('.input-with-dropdown-unit').find('input').parent().parent().addClass('display-flex');
            $('.input-with-dropdown-unit').find('input').parent().addClass('input-with-dropdown');
            $('.input-with-dropdown-unit').find('.tt-input-dropdown').removeClass('hide');

            var data_units = [];
            var lab_units_input = units.split('|');
            jQuery.each(lab_units_input, function (i, val) {

                var active = '';
                var lab_unit = val.split('#');

                if (lab_unit[1] === '1') {
                    active = ' class="active"';
                    default_unit = lab_unit[0];
                    $('.input-with-dropdown-unit').find('.input-with-dropdown').append('<i class="icon-append icon-append-unit">' + default_unit + '</i>');
                }

                item =
                    '<li' + active + '>' +
                    '<a class="tt-select-value tt-select-integrity-unit-value" data-format-value="' + lab_unit[0] + '" href="#">' + lab_unit[0] + '</a>' +
                    '</li>';
                $('.input-with-dropdown-unit').find('ul.dropdown-menu').append(item);

                data_units.push({id: lab_unit[0], text: lab_unit[0]});
            });

            validator.reinitializeSelect2($('.integrity_value_from_field_unit_1'), 'input-sm tt-select2', 'data-range="from"', data_units, false);
            validator.reinitializeSelect2($('.integrity_value_till_field_unit_1'), 'input-sm tt-select2', 'data-range="till"', data_units, false);

        } else {
            $('.input-with-dropdown-unit').find('input').parent().parent().removeClass('display-flex');
            $('.input-with-dropdown-unit').find('input').parent().removeClass('input-with-dropdown');
            $('.input-with-dropdown-unit').find('.tt-input-dropdown').addClass('hide');

            validator.reinitializeSelect2($('.integrity_value_from_field_unit_1'), 'input-sm tt-select2', 'data-range="from"', [], false);
            validator.reinitializeSelect2($('.integrity_value_till_field_unit_1'), 'input-sm tt-select2', 'data-range="till"', [], false);
        }
    }
}

function setIntegrityFieldSelection(name, inputName, classString, form) {
    var integrityDataViewField = $(form).find('[name="' + name + '"]').parent();

    if (integrityDataViewField.length) {
        var data_range = '';
        var data_range_string = '';
        if ($(form).find('[name="' + name + '"]').length) {
            if (/data-range=/.test($(form).find('[name="' + name + '"]')[0].outerHTML)) {
                data_range = $($(form).find('[name="' + name + '"]'))[0].outerHTML.substr($(form).find('[name="' + name + '"]')[0].outerHTML.indexOf('data-range=') + 12, 4);
                data_range_string = ' data-range="' + data_range + '"';
            }
        }

        var view_ids = [];

        if (form.prop('id') === 'table_data_views_integrities_create_form' || form.prop('id') === 'table_data_views_integrities_form'
            || form.prop('id') === 'table_data_views_restrictions_create_form' || form.prop('id') === 'table_data_views_restrictions_form') {

            if (!utils.isUndefined($(form).find('[name="integrity_data_collection_type"]').find(":selected").data("viewIds"))) {
                var splitted_data_views = String($(form).find('[name="integrity_data_collection_type"]').find(":selected").data("viewIds")).split('|');
                jQuery.each(splitted_data_views, function (i, val) {

                    view_ids.push(val);
                });
            }

		} else if (form.prop('id') === 'table_aggregation_create_form' || form.prop('id') === 'table_aggregation_definition_detail_form') {

            var model_name = name;
            if (/^rule_data_view_field_/.test(name) || /^rule_reference_date_/.test(name)) {
                model_name = 'source_data_view_field';
            }

            if ($(form).find('[name="' + model_name + '_model_view_ids"]').length) {
				var splitted_data_views = $(form).find('[name="' + model_name + '_model_view_ids"]').val().split('|');
				jQuery.each(splitted_data_views, function (i, val) {

					view_ids.push(val);
				});
			}

        } else {

            // Einträge der Stammdatenansichten
            jQuery.each($('#table_data_collection_type_master_views').dataTable().fnGetData(), function (i, val) {

                view_ids.push(val[2].toString());
            });

            // Einträge der Verlaufsansichten (Register)
            jQuery.each($('#table_data_collection_type_course_views_register').dataTable().fnGetData(), function (i, val) {

                view_ids.push(val[2].toString());
            });

			// Einträge der Fragebögen
			jQuery.each($('#table_data_collection_type_questionnaires').dataTable().fnGetData(), function (i, val) {

				view_ids.push(val[2].toString());
			});

            // Einträge der Verlaufsansichten (Studie)
            jQuery.each($('#dd_course_views').nestable('serialize'), function (i, val) {

                view_ids.push(val.viewId.toString());

                if (!utils.isUndefined(val.children)) {

                    jQuery.each(val.children, function (j, child) {
                        view_ids.push(child.viewId.toString());
                    });
                }
            });
        }

        var data = [];

        if (/^date_fields_/.test(inputName) && !(name === "integrity_age_from_field" || name === "integrity_age_till_field")) {
            data.push({ id: '-1|now', text: Lang.get('tripletrax.today'), controlType: '', dataType: '', controlValues: '', additionalField: '', units: '', range: data_range, formatFields: '', matchField: '', table: '' });
            data.push({ id: '-1|exam_date', text: Lang.get('tripletrax.exam_date'), controlType: '', dataType: '', controlValues: '', additionalField: '', units: '', range: data_range, formatFields: '', matchField: '', table: '' });
            data.push({ id: '-1|begin_calendar_year', text: Lang.get('tripletrax.begin_calendar_year'), controlType: '', dataType: '', controlValues: '', additionalField: '', units: '', range: data_range, formatFields: '', matchField: '', table: '' });
            data.push({ id: '-1|end_calendar_year', text: Lang.get('tripletrax.end_calendar_year'), controlType: '', dataType: '', controlValues: '', additionalField: '', units: '', range: data_range, formatFields: '', matchField: '', table: '' });
            data.push({ id: '-1|begin_quarter', text: Lang.get('tripletrax.begin_quarter'), controlType: '', dataType: '', controlValues: '', additionalField: '', units: '', range: data_range, formatFields: '', matchField: '', table: '' });
            data.push({ id: '-1|end_quarter', text: Lang.get('tripletrax.end_quarter'), controlType: '', dataType: '', controlValues: '', additionalField: '', units: '', range: data_range, formatFields: '', matchField: '', table: '' });
            data.push({ id: '-1|begin_month', text: Lang.get('tripletrax.begin_month'), controlType: '', dataType: '', controlValues: '', additionalField: '', units: '', range: data_range, formatFields: '', matchField: '', table: '' });
            data.push({ id: '-1|end_month', text: Lang.get('tripletrax.end_month'), controlType: '', dataType: '', controlValues: '', additionalField: '', units: '', range: data_range, formatFields: '', matchField: '', table: '' });
        }

        if (inputName !== '' && $('#' + inputName + '').length) {
            $.each($.parseJSON($('#' + inputName + '').val()), function (index, field) {
                if (!utils.isUndefined(field.assigned_view_ids) && field.assigned_view_ids !== '') {
                    var assignedViewIds = field.assigned_view_ids.toString().split('|');
                    var intersect = utils.arrayIntersect(view_ids, assignedViewIds);

                    if (intersect.length) {
                        data.push({
                            id: field.id + '|' + field.name,
                            text: field.desc + ' (' + field.name + ')',
                            controlType: field.control_type,
                            dataType: field.data_type,
                            controlValues: field.control_values,
                            additionalField: field.additional_field,
                            units: field.units,
                            range: data_range,
                            formatFields: field.format_fields,
                            tableType: field.table_type,
                            matchField: field.match_field,
                            table: field.table,
                            assignedFields: field.assigned_fields
                        });
                    }
                }
            });
        }

        validator.reinitializeSelect2($(integrityDataViewField), 'input-sm tt-select2 ' + classString, data_range_string, data, false);

        if (name === "integrity_age_from_field" || name === "integrity_age_till_field") {
            $(form).find('[name="' + name + '"]').val($(form).find('[name="' + name + '"]').parents('form').find('.tt-birth-date-data-view').val()).trigger('change.select2');
        }
    }
}

function setAggregationPeriodTableSelection(name, inputName, classString, form) {
    var integrityDataViewField = $(form).find('[name="' + name + '"]').parent();

    if (integrityDataViewField.length) {

        var view_ids = [];

        var model_name = '';
        if (/^source_data_view_period_table/.test(name)) {
            model_name = 'source_data_view_field';
        } else if (/^target_data_view_period_table/.test(name)) {
            model_name = 'target_data_view_field';
        }

        if ($(form).find('[name="' + model_name + '_model_view_ids"]').length) {
            var splitted_data_views = $(form).find('[name="' + model_name + '_model_view_ids"]').val().split('|');
            jQuery.each(splitted_data_views, function (i, val) {

                view_ids.push(val);
            });
        }

        var data = [];

        if (inputName !== '' && $('#' + inputName + '').length) {
            $.each($.parseJSON($('#' + inputName + '').val()), function (index, field) {
                if (!utils.isUndefined(field.assigned_view_ids) && field.assigned_view_ids !== '') {
                    var assignedViewIds = field.assigned_view_ids.toString().split('|');
                    var intersect = utils.arrayIntersect(view_ids, assignedViewIds);

                    if (intersect.length) {
                        data.push({
                            id: '0|' + field.table,
                            text: field.table,
                            assignedFields: field.assigned_fields
                        });
                    }
                }
            });
        }

        validator.reinitializeSelect2($(integrityDataViewField), 'input-sm tt-select2 ' + classString, '', data, false);
    }
}

function setIntegrityComboboxItems(form, tableTypeName, doLoadDataViewFields) {

    if (doLoadDataViewFields) {
        setIntegrityFieldSelection('integrity_data_view_field', 'all_fields_with_examination', 'tt-integrity-field', form);
    }
    setIntegrityFieldSelection('integrity_depending_field', 'all_fields', 'tt-integrity-field tt-integrity-depending-field', form);

    setIntegrityFieldSelection('integrity_age_from_field', 'all_date_fields', 'tt-integrity-field', form);
    setIntegrityFieldSelection('integrity_age_till_field', 'all_date_fields', 'tt-integrity-field', form);
    setIntegrityFieldSelection('integrity_value_from_date_field', 'date_fields_' + tableTypeName, 'tt-integrity-field validation-group-norm-date-from', form);
    setIntegrityFieldSelection('integrity_value_till_date_field', 'date_fields_' + tableTypeName, 'tt-integrity-field validation-group-norm-date-till tt-disabled-integrity-select2', form);
    setIntegrityFieldSelection('integrity_field_value_from_date_field', 'date_fields_' + tableTypeName, 'tt-integrity-field validation-group-norm-date-from', form);
    setIntegrityFieldSelection('integrity_field_value_till_date_field', 'date_fields_' + tableTypeName, 'tt-integrity-field validation-group-norm-date-till tt-disabled-integrity-select2', form);
    // setIntegrityFieldSelection('integrity_depending_field_value_from_date_field', 'date_fields_' + tableTypeName, 'tt-integrity-field validation-group-norm-date-from', form);
    // setIntegrityFieldSelection('integrity_depending_field_value_till_date_field', 'date_fields_' + tableTypeName, 'tt-integrity-field validation-group-norm-date-till tt-disabled-integrity-select2', form);

    setIntegrityFieldSelection('integrity_value_from_field', 'number_fields_' + tableTypeName, 'tt-integrity-field tt-integrity-deviation-value-field validation-group-range-input-from', form);
    setIntegrityFieldSelection('integrity_value_till_field', 'number_fields_' + tableTypeName, 'tt-integrity-field tt-integrity-deviation-value-field tt-disabled-integrity-select2 validation-group-range-input-till', form);
    setIntegrityFieldSelection('integrity_field_value_from_field', 'number_fields_' + tableTypeName, 'tt-integrity-field tt-integrity-deviation-value-field validation-dependency-group-range-input-from', form);
    setIntegrityFieldSelection('integrity_field_value_till_field', 'number_fields_' + tableTypeName, 'tt-integrity-field tt-integrity-deviation-value-field tt-disabled-integrity-select2 validation-dependency-group-range-input-till', form);
    // setIntegrityFieldSelection('integrity_depending_field_value_from_field', 'number_fields_' + tableTypeName, 'tt-integrity-field tt-integrity-deviation-value-field validation-depending-dependency-group-range-input-from', form);
    // setIntegrityFieldSelection('integrity_depending_field_value_till_field', 'number_fields_' + tableTypeName, 'tt-integrity-field tt-integrity-deviation-value-field tt-disabled-integrity-select2 validation-depending-dependency-group-range-input-till', form);
}

function saveOrAddNewDataViewIntegrity(element, form, newIntegrity) {

    var control_type = '';
    var data_type = '';
    if (form.id === "table_data_views_integrities_create_form" || form.id === "table_data_views_integrities_form") {
        control_type = $('#table_data_views_integrities_dialog').find('[name="control_type"]').val();
        data_type = $('#table_data_views_integrities_dialog').find('[name="data_type"]').val();
    }

    // Allgemeine Angaben
    var integrity_data_collection_type_id = $(form).find('[name="integrity_data_collection_type"]').select2('data')[0].id;
    var integrity_data_collection_type_name = $(form).find('[name="integrity_data_collection_type"]').select2('data')[0].text;
    var integrity_description = $(form).find('[name="integrity_description"]').val();
	var integrity_valid_from = '';
	var valid_from = $(form).find('[name="integrity_valid_from"]').data('picker').getDate();
	if ($(form).find('[name="integrity_valid_from"]').val() !== '' && !utils.isUndefined(valid_from)) {
		integrity_valid_from = utils.dateToString(valid_from);
	}
	var integrity_valid_till = '';
	var valid_till = $(form).find('[name="integrity_valid_till"]').data('picker').getDate();
	if ($(form).find('[name="integrity_valid_till"]').val() !== '' && !utils.isUndefined(valid_till)) {
		integrity_valid_till = utils.dateToString(valid_till);
	}
    var integrity_integritytype = '';
    if (!utils.isUndefined($(form).find('[name="integrity_integritytype"]:checked')) && $(form).find('[name="integrity_integritytype"]:checked').length > 0) {
        integrity_integritytype = $(form).find('[name="integrity_integritytype"]:checked').val();
    }
    var integrity_gender = '';
    if (!utils.isUndefined($(form).find('[name="integrity_gender"]:checked')) && $(form).find('[name="integrity_gender"]:checked').length > 0) {
        integrity_gender = $(form).find('[name="integrity_gender"]:checked').val();
    }
    var integrity_type_id = '';
    var integrity_type_name = '';
    if (!utils.isUndefined($(form).find('[name="integrity_type"]').select2('data'))) {
        integrity_type_id = $(form).find('[name="integrity_type"]').select2('data')[0].id;
        integrity_type_name = $(form).find('[name="integrity_type"]').select2('data')[0].text;
    } else {
        integrity_type_name = trans('tripletrax.custom_rule');
    }
    var integrity_custom_rule = '';
    if (!utils.isUndefined($(form).find('[name="integrity_custom_rule"]').select2('data'))) {
        integrity_custom_rule = $(form).find('[name="integrity_custom_rule"]').select2('data')[0].id;
    }

    // Alter von
    var select_age_from_field = $(form).find('[name="integrity_age_from_field"]').select2('data')[0];
    var integrity_age_from_data_view_id = '0';
    var integrity_age_from_data_view_name = '';
    var integrity_age_from_plus_minus = '';
    var integrity_age_from_value = '0';
    var integrity_age_from_range = '';
    if (!utils.isUndefined(select_age_from_field) && select_age_from_field.text !== '' && $(form).find('[name="integrity_age_from_range"]').val() !== '') {
        integrity_age_from_data_view_id = select_age_from_field.id.split('|')[0];
        integrity_age_from_data_view_name = select_age_from_field.id.split('|')[1];

        integrity_age_from_plus_minus = '+';
        if ($(form).find('[name="integrity_age_from_plus_minus"]')[0].checked) {
            integrity_age_from_plus_minus = '-';
        }
        integrity_age_from_value = $(form).find('[name="integrity_age_from_range"]').val();
        integrity_age_from_range = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_age_from_range"]'));
    }

    // Alter bis
    var select_age_till_field = $(form).find('[name="integrity_age_till_field"]').select2('data')[0];
    var integrity_age_till_data_view_id = '0';
    var integrity_age_till_data_view_name = '';
    var integrity_age_till_plus_minus = '';
    var integrity_age_till_value = '0';
    var integrity_age_till_range = '';
    if (!utils.isUndefined(select_age_till_field) && select_age_till_field.text !== '' && $(form).find('[name="integrity_age_till_range"]').val() !== '') {
        integrity_age_till_data_view_id = select_age_till_field.id.split('|')[0];
        integrity_age_till_data_view_name = select_age_till_field.id.split('|')[1];

        integrity_age_till_plus_minus = '+';
        if ($(form).find('[name="integrity_age_till_plus_minus"]')[0].checked) {
            integrity_age_till_plus_minus = '-';
        }
        integrity_age_till_value = $(form).find('[name="integrity_age_till_range"]').val();
        integrity_age_till_range = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_age_till_range"]'));
    }

    var integrity_value = '';
    var integrity_completeness_frequency = '';
    var integrity_optional = '0';
    var integrity_mandatory_field = '0';
    var integrity_unit = '';
    var integrity_logical_operator_from = '';
    var integrity_value_from = '';
    var integrity_value_from_data_view_id = '0';
    var integrity_value_from_data_view_name = '';
    var integrity_value_from_up_down = '';
    var integrity_value_from_value = '';
    var integrity_value_from_range = '';
    var integrity_value_from_unit_1 = '';
    var integrity_value_from_unit_2 = '';
    var integrity_logical_operator_till = '';
    var integrity_value_till = '';
    var integrity_value_till_data_view_id = '0';
    var integrity_value_till_data_view_name = '';
    var integrity_value_till_up_down = '';
    var integrity_value_till_value = '';
    var integrity_value_till_range = '';
    var integrity_value_till_unit_1 = '';
    var integrity_value_till_unit_2 = '';
    var integrity_range_of_values = '';
    var integrity_deviation_percentage_value = '';
    var integrity_deviation_down = '-1';
    var integrity_period_down_value = '0';
    var integrity_period_down_range = '';
    var integrity_deviation_up = '-1';
    var integrity_period_up_value = '0';
    var integrity_period_up_range = '';
    var integrity_dep_value = '';
    var integrity_dep_unit = '';
    var integrity_dep_data_view_id = '0';
    var integrity_dep_data_view_name = '';
    var integrity_dep_logical_operator_from = '';
    var integrity_dep_value_from = '';
    var integrity_dep_value_from_data_view_id = '0';
    var integrity_dep_value_from_data_view_name = '';
    var integrity_dep_value_from_up_down = '';
    var integrity_dep_value_from_value = '';
    var integrity_dep_value_from_range = '';
    var integrity_dep_logical_operator_till = '';
    var integrity_dep_value_till = '';
    var integrity_dep_value_till_data_view_id = '0';
    var integrity_dep_value_till_data_view_name = '';
    var integrity_dep_value_till_up_down = '';
    var integrity_dep_value_till_value = '';
    var integrity_dep_value_till_range = '';
    var integrity_dep_range_of_values = '';

    // Vollständigkeit
    if (integrity_type_id === 'completeness') {

        if (!utils.isUndefined($(form).find('[name="completeness_frequency"]:checked')) && $(form).find('[name="completeness_frequency"]:checked').length > 0) {
            integrity_completeness_frequency = $(form).find('[name="completeness_frequency"]:checked').val();
        }
        if ($(form).find('[name="completeness_optional"]')[0].checked) {
            integrity_optional = '1';
        }
        if ($(form).find('[name="completeness_mandatory_field"]')[0].checked) {
            integrity_mandatory_field = '1';
        }
        jQuery.each($(form).find('[name="completeness_range_of_values"]').select2('data'), function (i, val) {
            if (integrity_range_of_values !== '') {
                integrity_range_of_values += '$';
            }
            integrity_range_of_values += val.id;
        });

    }

    // Wertebereich
    if (integrity_type_id === 'range') {

        if (control_type === 'input' || control_type === 'input_with_additionalfield' || control_type === 'textarea') {

            // Wert von
            var select_logical_operator_from = $(form).find('[name="integrity_logical_from_field"]').select2('data')[0];
            if (!utils.isUndefined(select_logical_operator_from) && select_logical_operator_from.text !== '') {
                integrity_logical_operator_from = select_logical_operator_from.id;
            }
            integrity_value_from = utils.stringToNumber($(form).find('[name="integrity_value_from"]').val());
            integrity_unit = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_value_from"]'));
            var select_value_from_field = $(form).find('[name="integrity_value_from_field"]').select2('data')[0];
            if (!utils.isUndefined(select_value_from_field) && select_value_from_field.text !== '') {
                integrity_value_from_data_view_id = select_value_from_field.id.split('|')[0];
                integrity_value_from_data_view_name = select_value_from_field.id.split('|')[1];
            }
            var select_value_from_field_unit_1 = $(form).find('[name="integrity_value_from_field_unit_1"]').select2('data')[0];
            if (!utils.isUndefined(select_value_from_field_unit_1) && select_value_from_field_unit_1.text !== '') {
                integrity_value_from_unit_1 = select_value_from_field_unit_1.id;
            }
            var select_value_from_field_unit_2 = $(form).find('[name="integrity_value_from_field_unit_2"]').select2('data')[0];
            if (!utils.isUndefined(select_value_from_field_unit_2) && select_value_from_field_unit_2.text !== '') {
                integrity_value_from_unit_2 = select_value_from_field_unit_2.id;
            }

            // Wert bis
            var select_logical_operator_till = $(form).find('[name="integrity_logical_till_field"]').select2('data')[0];
            if (!utils.isUndefined(select_logical_operator_till) && select_logical_operator_till.text !== '') {
                integrity_logical_operator_till = select_logical_operator_till.id;
            }
            integrity_value_till = utils.stringToNumber($(form).find('[name="integrity_value_till"]').val());
            var select_value_till_field = $(form).find('[name="integrity_value_till_field"]').select2('data')[0];
            if (!utils.isUndefined(select_value_till_field) && select_value_till_field.text !== '') {
                integrity_value_till_data_view_id = select_value_till_field.id.split('|')[0];
                integrity_value_till_data_view_name = select_value_till_field.id.split('|')[1];
            }
            var select_value_till_field_unit_1 = $(form).find('[name="integrity_value_till_field_unit_1"]').select2('data')[0];
            if (!utils.isUndefined(select_value_till_field_unit_1) && select_value_till_field_unit_1.text !== '') {
                integrity_value_till_unit_1 = select_value_till_field_unit_1.id;
            }
            var select_value_till_field_unit_2 = $(form).find('[name="integrity_value_till_field_unit_2"]').select2('data')[0];
            if (!utils.isUndefined(select_value_till_field_unit_2) && select_value_till_field_unit_2.text !== '') {
                integrity_value_till_unit_2 = select_value_till_field_unit_2.id;
            }

        } else if (control_type === 'date_panel' || control_type === 'date_range') {

            // Wert von
            var select_logical_operator_from = $(form).find('[name="integrity_logical_from_date_field"]').select2('data')[0];
            if (!utils.isUndefined(select_logical_operator_from) && select_logical_operator_from.text !== '') {
                integrity_logical_operator_from = select_logical_operator_from.id;
            }
            var select_value_from_date_field = $(form).find('[name="integrity_value_from_date_field"]').select2('data')[0];
            if (!utils.isUndefined(select_value_from_date_field) && select_value_from_date_field.text !== '' && $(form).find('[name="integrity_value_from_date_range"]').val() !== '') {
                integrity_value_from_data_view_id = select_value_from_date_field.id.split('|')[0];
                integrity_value_from_data_view_name = select_value_from_date_field.id.split('|')[1];

                integrity_value_from_up_down = '+';
                if ($(form).find('[name="integrity_value_from_plus_minus"]')[0].checked) {
                    integrity_value_from_up_down = '-';
                }
                integrity_value_from_value = $(form).find('[name="integrity_value_from_date_range"]').val();
                integrity_value_from_range = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_value_from_date_range"]'));
            }

            // Wert bis
            var select_logical_operator_till = $(form).find('[name="integrity_logical_till_date_field"]').select2('data')[0];
            if (!utils.isUndefined(select_logical_operator_till) && select_logical_operator_till.text !== '') {
                integrity_logical_operator_till = select_logical_operator_till.id;
            }
            var select_value_till_date_field = $(form).find('[name="integrity_value_till_date_field"]').select2('data')[0];
            if (!utils.isUndefined(select_value_till_date_field) && select_value_till_date_field.text !== '' && $(form).find('[name="integrity_value_till_date_range"]').val() !== '') {
                integrity_value_till_data_view_id = select_value_till_date_field.id.split('|')[0];
                integrity_value_till_data_view_name = select_value_till_date_field.id.split('|')[1];

                integrity_value_till_up_down = '+';
                if ($(form).find('[name="integrity_value_till_plus_minus"]')[0].checked) {
                    integrity_value_till_up_down = '-';
                }
                integrity_value_till_value = $(form).find('[name="integrity_value_till_date_range"]').val();
                integrity_value_till_range = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_value_till_date_range"]'));
            }

        } else {

            jQuery.each($(form).find('[name="integrity_control_type"]').select2('data'), function (i, val) {
                if (integrity_range_of_values !== '') {
                    integrity_range_of_values += '$';
                }
                integrity_range_of_values += val.id;
            });

        }
    }

    // Abweichung
    if (integrity_type_id === 'deviation') {
        if ((control_type === 'input' || control_type === 'input_with_additionalfield' || control_type === 'textarea') && (data_type === 'integer' || data_type === 'decimal')) {

            integrity_deviation_percentage_value = $(form).find('[name="integrity_deviation_percentage_value"]:checked');
            if (integrity_deviation_percentage_value.length) {
                integrity_deviation_percentage_value = integrity_deviation_percentage_value.val();
            } else {
                integrity_deviation_percentage_value = '';
            }

            // Abweichung nach hinten (zeitlich gesehen)
            integrity_deviation_down = $(form).find('[name="integrity_deviation_down"]').val();
            if (integrity_deviation_down !== '') {
                integrity_unit = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_deviation_down"]'));
                integrity_period_down_value = $(form).find('[name="integrity_period_down"]').val();
                integrity_period_down_range = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_period_down"]'));
            } else {
                integrity_deviation_down = '-1';
            }

            // Abweichung nach vorn (zeitlich gesehen)
            integrity_deviation_up = $(form).find('[name="integrity_deviation_up"]').val();
            if (integrity_deviation_up !== '') {
                integrity_unit = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_deviation_up"]'));
                integrity_period_up_value = $(form).find('[name="integrity_period_up"]').val();
                integrity_period_up_range = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_period_up"]'));
            } else {
                integrity_deviation_up = '-1';
            }

        } else {

            integrity_deviation_down = '0';
            integrity_deviation_up = '0';

        }
    }

    // Abhängigkeit
    if (integrity_type_id === 'dependency') {

        // Wert
        if ($(form).find('[name="integrity_existing_value"]')[0].checked) {

            integrity_value = 'existing';

        } else if ($(form).find('[name="integrity_not_existing_value"]')[0].checked) {

            integrity_value = 'not_existing';

        } else {

            if (control_type === 'input' || control_type === 'input_with_additionalfield' || control_type === 'textarea') {

                if (data_type === 'integer' || data_type === 'decimal') {

                    // Wert von
                    var select_logical_operator_from = $(form).find('[name="integrity_field_logical_from_field"]').select2('data')[0];
                    if (!utils.isUndefined(select_logical_operator_from) && select_logical_operator_from.text !== '') {
                        integrity_logical_operator_from = select_logical_operator_from.id;
                    }
                    integrity_value_from = utils.stringToNumber($(form).find('[name="integrity_field_value_from"]').val());
                    integrity_unit = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_field_value_from"]'));
                    var select_value_from_field = $(form).find('[name="integrity_field_value_from_field"]').select2('data')[0];
                    if (!utils.isUndefined(select_value_from_field) && select_value_from_field.text !== '') {
                        integrity_value_from_data_view_id = select_value_from_field.id.split('|')[0];
                        integrity_value_from_data_view_name = select_value_from_field.id.split('|')[1];
                    }

                    // Wert bis
                    var select_logical_operator_till = $(form).find('[name="integrity_field_logical_till_field"]').select2('data')[0];
                    if (!utils.isUndefined(select_logical_operator_till) && select_logical_operator_till.text !== '') {
                        integrity_logical_operator_till = select_logical_operator_till.id;
                    }
                    integrity_value_till = utils.stringToNumber($(form).find('[name="integrity_field_value_till"]').val());
                    var select_value_till_field = $(form).find('[name="integrity_field_value_till_field"]').select2('data')[0];
                    if (!utils.isUndefined(select_value_till_field) && select_value_till_field.text !== '') {
                        integrity_value_till_data_view_id = select_value_till_field.id.split('|')[0];
                        integrity_value_till_data_view_name = select_value_till_field.id.split('|')[1];
                    }

                } else {

                    integrity_range_of_values = $(form).find('[name="integrity_field_input"]').val();

                }

            } else if (control_type === 'date_panel' || control_type === 'date_range') {

                // Wert von
                var select_logical_operator_from = $(form).find('[name="integrity_field_logical_from_date_field"]').select2('data')[0];
                if (!utils.isUndefined(select_logical_operator_from) && select_logical_operator_from.text !== '') {
                    integrity_logical_operator_from = select_logical_operator_from.id;
                }
                var select_value_from_date_field = $(form).find('[name="integrity_field_value_from_date_field"]').select2('data')[0];
                if (!utils.isUndefined(select_value_from_date_field) && select_value_from_date_field.text !== '' && $(form).find('[name="integrity_field_value_from_date_range"]').val() !== '') {
                    integrity_value_from_data_view_id = select_value_from_date_field.id.split('|')[0];
                    integrity_value_from_data_view_name = select_value_from_date_field.id.split('|')[1];

                    integrity_value_from_up_down = '+';
                    if ($(form).find('[name="integrity_field_value_from_plus_minus"]')[0].checked) {
                        integrity_value_from_up_down = '-';
                    }
                    integrity_value_from_value = $(form).find('[name="integrity_field_value_from_date_range"]').val();
                    integrity_value_from_range = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_field_value_from_date_range"]'));
                }

                // Wert bis
                var select_logical_operator_till = $(form).find('[name="integrity_field_logical_till_date_field"]').select2('data')[0];
                if (!utils.isUndefined(select_logical_operator_till) && select_logical_operator_till.text !== '') {
                    integrity_logical_operator_till = select_logical_operator_till.id;
                }
                var select_value_till_date_field = $(form).find('[name="integrity_field_value_till_date_field"]').select2('data')[0];
                if (!utils.isUndefined(select_value_till_date_field) && select_value_till_date_field.text !== '' && $(form).find('[name="integrity_field_value_till_date_range"]').val() !== '') {
                    integrity_value_till_data_view_id = select_value_till_date_field.id.split('|')[0];
                    integrity_value_till_data_view_name = select_value_till_date_field.id.split('|')[1];

                    integrity_value_till_up_down = '+';
                    if ($(form).find('[name="integrity_field_value_till_plus_minus"]')[0].checked) {
                        integrity_value_till_up_down = '-';
                    }
                    integrity_value_till_value = $(form).find('[name="integrity_field_value_till_date_range"]').val();
                    integrity_value_till_range = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_field_value_till_date_range"]'));
                }

            } else {

                jQuery.each($(form).find('[name="integrity_field_list"]').select2('data'), function (i, val) {
                    if (integrity_range_of_values !== '') {
                        integrity_range_of_values += '$';
                    }
                    integrity_range_of_values += val.id;
                });

            }

        }

        var integrity_depending_field = $(form).find('[name="integrity_depending_field"]').select2('data')[0];
        if (!utils.isUndefined(integrity_depending_field) && integrity_depending_field.text !== '') {
            integrity_dep_data_view_id = integrity_depending_field.id.split('|')[0];
            integrity_dep_data_view_name = integrity_depending_field.id.split('|')[1];
        }

        integrity_completeness_frequency = $(form).find('[name="integrity_dependency_frequency"]:checked').val();
        if ($(form).find('[name="integrity_dependency_optional"]')[0].checked) {
            integrity_optional = '1';
        }

        var dep_control_type = '';
        var dep_data_type = '';

        if (!utils.isUndefined($(form).find('[name="integrity_depending_field"]').select2('val')) && $(form).find('[name="integrity_depending_field"]').select2('val') !== '') {
            dep_control_type = $(form).find('[name="integrity_depending_field"]').select2('data')[0].controlType;
            dep_data_type = $(form).find('[name="integrity_depending_field"]').select2('data')[0].dataType;
        }

        if (integrity_completeness_frequency === 'no') {

            if ($(form).find('[name="integrity_existing_depending_value"]')[0].checked) {

                integrity_dep_value = 'existing';

            } else if ($(form).find('[name="integrity_not_existing_depending_value"]')[0].checked) {

                integrity_dep_value = 'not_existing';

            } else {

                if (dep_control_type === 'input' || dep_control_type === 'input_with_additionalfield' || dep_control_type === 'textarea') {

                    if (dep_data_type === 'integer' || dep_data_type === 'decimal') {

                        // Wert von
                        var dep_select_logical_operator_from = $(form).find('[name="integrity_depending_field_logical_from_field"]').select2('data')[0];
                        if (!utils.isUndefined(dep_select_logical_operator_from) && dep_select_logical_operator_from.text !== '') {
                            integrity_dep_logical_operator_from = dep_select_logical_operator_from.id;
                        }
                        integrity_dep_value_from = utils.stringToNumber($(form).find('[name="integrity_depending_field_value_from"]').val());
                        integrity_dep_unit = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_depending_field_value_from"]'));
                        var dep_select_value_from_field = $(form).find('[name="integrity_depending_field_value_from_field"]').select2('data')[0];
                        if (!utils.isUndefined(dep_select_value_from_field) && dep_select_value_from_field.text !== '') {
                            integrity_dep_value_from_data_view_id = dep_select_value_from_field.id.split('|')[0];
                            integrity_dep_value_from_data_view_name = dep_select_value_from_field.id.split('|')[1];
                        }

                        // Wert bis
                        var dep_select_logical_operator_till = $(form).find('[name="integrity_depending_field_logical_till_field"]').select2('data')[0];
                        if (!utils.isUndefined(dep_select_logical_operator_till) && dep_select_logical_operator_till.text !== '') {
                            integrity_dep_logical_operator_till = dep_select_logical_operator_till.id;
                        }
                        integrity_dep_value_till = utils.stringToNumber($(form).find('[name="integrity_depending_field_value_till"]').val());
                        var dep_select_value_till_field = $(form).find('[name="integrity_depending_field_value_till_field"]').select2('data')[0];
                        if (!utils.isUndefined(dep_select_value_till_field) && dep_select_value_till_field.text !== '') {
                            integrity_dep_value_till_data_view_id = dep_select_value_till_field.id.split('|')[0];
                            integrity_dep_value_till_data_view_name = dep_select_value_till_field.id.split('|')[1];
                        }

                    } else {

                        integrity_dep_range_of_values = $(form).find('[name="integrity_depending_field_input"]').val();

                    }

                } else if (dep_control_type === 'date_panel' || dep_control_type === 'date_range') {

                    // Wert von
                    var dep_select_logical_operator_from = $(form).find('[name="integrity_depending_field_logical_from_date_field"]').select2('data')[0];
                    if (!utils.isUndefined(dep_select_logical_operator_from) && dep_select_logical_operator_from.text !== '') {
                        integrity_dep_logical_operator_from = dep_select_logical_operator_from.id;
                    }
                    var dep_select_value_from_date_field = $(form).find('[name="integrity_depending_field_value_from_date_field"]').select2('data')[0];
                    if (!utils.isUndefined(dep_select_value_from_date_field) && dep_select_value_from_date_field.text !== '' && $(form).find('[name="integrity_depending_field_value_from_date_range"]').val() !== '') {
                        integrity_dep_value_from_data_view_id = dep_select_value_from_date_field.id.split('|')[0];
                        integrity_dep_value_from_data_view_name = dep_select_value_from_date_field.id.split('|')[1];

                        integrity_dep_value_from_up_down = '+';
                        if ($(form).find('[name="integrity_depending_field_value_from_plus_minus"]')[0].checked) {
                            integrity_dep_value_from_up_down = '-';
                        }
                        integrity_dep_value_from_value = $(form).find('[name="integrity_depending_field_value_from_date_range"]').val();
                        integrity_dep_value_from_range = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_depending_field_value_from_date_range"]'));
                    }

                    // Wert bis
                    var dep_select_logical_operator_till = $(form).find('[name="integrity_depending_field_logical_till_date_field"]').select2('data')[0];
                    if (!utils.isUndefined(dep_select_logical_operator_till) && dep_select_logical_operator_till.text !== '') {
                        integrity_dep_logical_operator_till = dep_select_logical_operator_till.id;
                    }
                    var dep_select_value_till_date_field = $(form).find('[name="integrity_depending_field_value_till_date_field"]').select2('data')[0];
                    if (!utils.isUndefined(dep_select_value_till_date_field) && dep_select_value_till_date_field.text !== '' && $(form).find('[name="integrity_depending_field_value_till_date_range"]').val() !== '') {
                        integrity_dep_value_till_data_view_id = dep_select_value_till_date_field.id.split('|')[0];
                        integrity_dep_value_till_data_view_name = dep_select_value_till_date_field.id.split('|')[1];

                        integrity_dep_value_till_up_down = '+';
                        if ($(form).find('[name="integrity_depending_field_value_till_plus_minus"]')[0].checked) {
                            integrity_dep_value_till_up_down = '-';
                        }
                        integrity_dep_value_till_value = $(form).find('[name="integrity_depending_field_value_till_date_range"]').val();
                        integrity_dep_value_till_range = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_depending_field_value_till_date_range"]'));
                    }

                } else {

                    jQuery.each($(form).find('[name="integrity_depending_field_list"]').select2('data'), function (i, val) {
                        if (integrity_dep_range_of_values !== '') {
                            integrity_dep_range_of_values += '$';
                        }
                        integrity_dep_range_of_values += val.id;
                    });

                }

            }
        } else {

            jQuery.each($(form).find('[name="integrity_depending_field_list"]').select2('data'), function (i, val) {
                if (integrity_dep_range_of_values !== '') {
                    integrity_dep_range_of_values += '$';
                }
                integrity_dep_range_of_values += val.id;
            });

        }
    }

    if (newIntegrity) {

        var table = $("#table_data_views_integrities");
        var dialog = $("#table_data_views_integrities_dialog");

        if (form.id === 'table_data_views_restrictions_create_form') {
            table = $("#table_data_views_restrictions");
            dialog = $("#table_data_views_restrictions_dialog");
        }

        table.dataTable().fnAddData([

                '',
                integrity_data_collection_type_name,
                integrity_description,
                integrity_type_name,
                integrity_type_id,
                integrity_integritytype,
                integrity_data_collection_type_id,
                integrity_gender,
                integrity_custom_rule,
                integrity_age_from_data_view_id,
                integrity_age_from_data_view_name,
                integrity_age_from_plus_minus,
                integrity_age_from_value,
                integrity_age_from_range,
                integrity_age_till_data_view_id,
                integrity_age_till_data_view_name,
                integrity_age_till_plus_minus,
                integrity_age_till_value,
                integrity_age_till_range,
                integrity_value,
                integrity_completeness_frequency,
                integrity_optional,
                integrity_unit,
                (integrity_value_from === '' && integrity_value_from_data_view_id === '0') ? '' : integrity_logical_operator_from,
                integrity_value_from,
                integrity_value_from_data_view_id,
                integrity_value_from_data_view_name,
                integrity_value_from_up_down,
                integrity_value_from_value,
                integrity_value_from_range,
			    (integrity_value_till === '' && integrity_value_till_data_view_id === '0') ? '' : integrity_logical_operator_till,
                integrity_value_till,
                integrity_value_till_data_view_id,
                integrity_value_till_data_view_name,
                integrity_value_till_up_down,
                integrity_value_till_value,
                integrity_value_till_range,
                integrity_range_of_values,
                integrity_deviation_percentage_value,
                integrity_deviation_down,
                integrity_period_down_value,
                integrity_period_down_range,
                integrity_deviation_up,
                integrity_period_up_value,
                integrity_period_up_range,
                integrity_dep_value,
                integrity_dep_unit,
                integrity_dep_data_view_id,
                integrity_dep_data_view_name,
			    (integrity_dep_value_from === '' && integrity_dep_value_from_data_view_id === '0') ? '' : integrity_dep_logical_operator_from,
                integrity_dep_value_from,
                integrity_dep_value_from_data_view_id,
                integrity_dep_value_from_data_view_name,
                integrity_dep_value_from_up_down,
                integrity_dep_value_from_value,
                integrity_dep_value_from_range,
			    (integrity_dep_value_till === '' && integrity_dep_value_till_data_view_id === '0') ? '' : integrity_dep_logical_operator_till,
                integrity_dep_value_till,
                integrity_dep_value_till_data_view_id,
                integrity_dep_value_till_data_view_name,
                integrity_dep_value_till_up_down,
                integrity_dep_value_till_value,
                integrity_dep_value_till_range,
                integrity_dep_range_of_values,
                integrity_mandatory_field,
                integrity_valid_from,
			    integrity_valid_till,
                integrity_value_from_unit_1,
                integrity_value_from_unit_2,
                integrity_value_till_unit_1,
                integrity_value_till_unit_2,
                '']
        );

        table.dataTable().$('tr.selected-row').removeClass('selected-row');
        dialog.find('.tt-content-datatable').find('.tt-delete').addClass('disabled');

        element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();

    } else {

        var dataTable = $(form).parents('.modal-content').find('.tt-datatable-dialog').dataTable();
        var tr = dataTable.$('tr.selected-row');
        var aPos = dataTable.fnGetPosition(tr[0]);

        // Sichtbare Spalten
        dataTable.fnGetNodes(aPos).children[0].textContent = integrity_data_collection_type_name;
        dataTable.fnGetData(aPos)[1] = integrity_data_collection_type_name;

        dataTable.fnGetNodes(aPos).children[1].textContent = integrity_description;
        dataTable.fnGetData(aPos)[2] = integrity_description;

        if (integrity_type_id !== 'restriction') {
            dataTable.fnGetNodes(aPos).children[2].textContent = integrity_type_name;
        }
        dataTable.fnGetData(aPos)[3] = integrity_type_name;

        // Nicht sichtbare Spalten
        dataTable.fnGetData(aPos)[4] = integrity_type_id;
        dataTable.fnGetData(aPos)[5] = integrity_integritytype;
        dataTable.fnGetData(aPos)[6] = integrity_data_collection_type_id;
        dataTable.fnGetData(aPos)[7] = integrity_gender;
        dataTable.fnGetData(aPos)[8] = integrity_custom_rule;
        dataTable.fnGetData(aPos)[9] = integrity_age_from_data_view_id;
        dataTable.fnGetData(aPos)[10] = integrity_age_from_data_view_name;
        dataTable.fnGetData(aPos)[11] = integrity_age_from_plus_minus;
        dataTable.fnGetData(aPos)[12] = integrity_age_from_value;
        dataTable.fnGetData(aPos)[13] = integrity_age_from_range;
        dataTable.fnGetData(aPos)[14] = integrity_age_till_data_view_id;
        dataTable.fnGetData(aPos)[15] = integrity_age_till_data_view_name;
        dataTable.fnGetData(aPos)[16] = integrity_age_till_plus_minus;
        dataTable.fnGetData(aPos)[17] = integrity_age_till_value;
        dataTable.fnGetData(aPos)[18] = integrity_age_till_range;
        dataTable.fnGetData(aPos)[19] = integrity_value;
        dataTable.fnGetData(aPos)[20] = integrity_completeness_frequency;
        dataTable.fnGetData(aPos)[21] = integrity_optional;
        dataTable.fnGetData(aPos)[22] = integrity_unit;
        dataTable.fnGetData(aPos)[23] = (integrity_value_from === '' && integrity_value_from_data_view_id === '0') ? '' : integrity_logical_operator_from;
        dataTable.fnGetData(aPos)[24] = integrity_value_from;
        dataTable.fnGetData(aPos)[25] = integrity_value_from_data_view_id;
        dataTable.fnGetData(aPos)[26] = integrity_value_from_data_view_name;
        dataTable.fnGetData(aPos)[27] = integrity_value_from_up_down;
        dataTable.fnGetData(aPos)[28] = integrity_value_from_value;
        dataTable.fnGetData(aPos)[29] = integrity_value_from_range;
        dataTable.fnGetData(aPos)[30] = (integrity_value_till === '' && integrity_value_till_data_view_id === '0') ? '' : integrity_logical_operator_till;
        dataTable.fnGetData(aPos)[31] = integrity_value_till;
        dataTable.fnGetData(aPos)[32] = integrity_value_till_data_view_id;
        dataTable.fnGetData(aPos)[33] = integrity_value_till_data_view_name;
        dataTable.fnGetData(aPos)[34] = integrity_value_till_up_down;
        dataTable.fnGetData(aPos)[35] = integrity_value_till_value;
        dataTable.fnGetData(aPos)[36] = integrity_value_till_range;
        dataTable.fnGetData(aPos)[37] = integrity_range_of_values;
        dataTable.fnGetData(aPos)[38] = integrity_deviation_percentage_value;
        dataTable.fnGetData(aPos)[39] = integrity_deviation_down;
        dataTable.fnGetData(aPos)[40] = integrity_period_down_value;
        dataTable.fnGetData(aPos)[41] = integrity_period_down_range;
        dataTable.fnGetData(aPos)[42] = integrity_deviation_up;
        dataTable.fnGetData(aPos)[43] = integrity_period_up_value;
        dataTable.fnGetData(aPos)[44] = integrity_period_up_range;
        dataTable.fnGetData(aPos)[45] = integrity_dep_value;
        dataTable.fnGetData(aPos)[46] = integrity_dep_unit;
        dataTable.fnGetData(aPos)[47] = integrity_dep_data_view_id;
        dataTable.fnGetData(aPos)[48] = integrity_dep_data_view_name;
        dataTable.fnGetData(aPos)[49] = (integrity_dep_value_from === '' && integrity_dep_value_from_data_view_id === '0') ? '' : integrity_dep_logical_operator_from;
        dataTable.fnGetData(aPos)[50] = integrity_dep_value_from;
        dataTable.fnGetData(aPos)[51] = integrity_dep_value_from_data_view_id;
        dataTable.fnGetData(aPos)[52] = integrity_dep_value_from_data_view_name;
        dataTable.fnGetData(aPos)[53] = integrity_dep_value_from_up_down;
        dataTable.fnGetData(aPos)[54] = integrity_dep_value_from_value;
        dataTable.fnGetData(aPos)[55] = integrity_dep_value_from_range;
        dataTable.fnGetData(aPos)[56] = (integrity_dep_value_till === '' && integrity_dep_value_till_data_view_id === '0') ? '' : integrity_dep_logical_operator_till;
        dataTable.fnGetData(aPos)[57] = integrity_dep_value_till;
        dataTable.fnGetData(aPos)[58] = integrity_dep_value_till_data_view_id;
        dataTable.fnGetData(aPos)[59] = integrity_dep_value_till_data_view_name;
        dataTable.fnGetData(aPos)[60] = integrity_dep_value_till_up_down;
        dataTable.fnGetData(aPos)[61] = integrity_dep_value_till_value;
        dataTable.fnGetData(aPos)[62] = integrity_dep_value_till_range;
        dataTable.fnGetData(aPos)[63] = integrity_dep_range_of_values;
        dataTable.fnGetData(aPos)[64] = integrity_mandatory_field;
        dataTable.fnGetData(aPos)[65] = integrity_valid_from;
        dataTable.fnGetData(aPos)[66] = integrity_valid_till;
        dataTable.fnGetData(aPos)[67] = integrity_value_from_unit_1;
        dataTable.fnGetData(aPos)[68] = integrity_value_from_unit_2;
        dataTable.fnGetData(aPos)[69] = integrity_value_till_unit_1;
        dataTable.fnGetData(aPos)[70] = integrity_value_till_unit_2;

        dataTable.fnStandingRedraw();

        $(form).parents('.modal-content').find('.tt-cancel-value-modal').click();
    }
}

function resetForm(element) {

    if (!$(element).find('form').hasClass('tt-no-reset-form')) {

        $("#content-detail").find('form').trigger('checkform.areYouSure');

        $(element).find('form').validate().resetForm();

        if (!$(element).find('form').hasClass('tt-no-reset-hidden-input')) {
            $(element).find('form').find('input[type="hidden"]:not([data-no-reset="no-reset-value"])').val("");
        }
        $('#content').find('.tt-content-detail').find('.tt-content-datatable').find('input[type="hidden"]:not([data-no-reset="no-reset-value"])').val("");
        $(element).find('.tt-select2.select2-hidden-accessible:not(.tt-no-reset-select2)').val(null).trigger('change.select2');
        $(element).find('.tt-select2:not(.tt-no-reset-select2)').removeAttr('disabled');
        $(element).find('.tt-datatable-dialog').dataTable().$('tr.selected-row').removeClass('selected-row');
        $('input:checked', $(element).find('.tt-datatable-dialog').dataTable().fnGetNodes()).prop('checked', false);

        $(element).find('.widget-dialog-title').removeClass('hide');
        $(element).find('.widget-dialog-content').addClass('hide');

        jQuery.each($(element).find('.tt-history'), function (i, val) {
            val.dataset.content = '';
        });

        jQuery.each($(element).find('form').find('.tt-date-dropdown'), function (i, val) {
            utils.setValueForInputWithDropDownField($(val).parent(), 'years', true);
        });
        $(element).find('.tt-select2[name$="_age_from_field"],.tt-select2[name$="_age_till_field"]').val($(element).find('.tt-birth-date-data-view').val()).trigger('change.select2');

        if ($(element).find('[name="begin_date"]').length) {
            $(element).find('[name="begin_date"]').data('picker').setDate(new Date());
        }
        if ($(element).find('[name="patient_begin_date"]').length) {
            $(element).find('[name="patient_begin_date"]').data('picker').setDate(new Date());
        }
        if ($(element).find('[name="exam_date"]').length) {
            $(element).find('[name="exam_date"]').data('picker').setDate(new Date());
        }
        if ($(element).find('[name="integrity_age_from_field"]').length) {
            setIntegrityFieldSelection('integrity_age_from_field', '', 'tt-integrity-field', $(element).find('form'));
        }
        if ($(element).find('[name="integrity_age_till_field"]').length) {
            setIntegrityFieldSelection('integrity_age_till_field', '', 'tt-integrity-field', $(element).find('form'));
        }
    }
}

module.exports.registerIntegritiesEvents = registerIntegritiesEvents;
module.exports.setIntegritySavedValues = setIntegritySavedValues;
module.exports.loadIntegrityComboboxValues = loadIntegrityComboboxValues;
module.exports.setIntegrityComboboxItems = setIntegrityComboboxItems;
module.exports.saveOrAddNewDataViewIntegrity = saveOrAddNewDataViewIntegrity;
module.exports.resetForm = resetForm;
module.exports.setIntegrityFieldSelection = setIntegrityFieldSelection;
module.exports.setAggregationPeriodTableSelection = setAggregationPeriodTableSelection;
